const ON_CHANGE_DEBOUNCE_TIMER = 300,
  currentDate = new Date(),
  PUB_SUB_EVENTS = {
    cartUpdate: "cart-update",
    quantityUpdate: "quantity-update",
    variantChange: "variant-change",
  };
let subscribers = {};
function subscribe(subscriberId, subscriber) {
  return (
    subscribers[subscriberId] === undefined && (subscribers[subscriberId] = []),
    (subscribers[subscriberId] = [...subscribers[subscriberId], subscriber]),
    function unsubscribe() {
      subscribers[subscriberId] = subscribers[subscriberId]["filter"]((incomingId) => {
        return incomingId !== subscriber;
      });
    }
  );
}
function publish(topic, event) {
  subscribers[topic] &&
    subscribers[topic]["forEach"]((handler) => {
      handler(event);
    });
}
class CartRemoveButton extends HTMLElement {
  constructor() {
    (super(),
      this["addEventListener"]("click", (event2) => {
        event2["preventDefault"]();
        const cartItems = this["closest"]("cart-items") || this["closest"]("cart-drawer-items");
        this["clearCart"]
          ? cartItems["clearCart"]()
          : cartItems["updateQuantity"](this["dataset"]["index"], 0);
      }));
  }
}
customElements["define"]("cart-remove-button", CartRemoveButton);
var forceClose = !![];
const today = new Date();
const formattedDate = today.toISOString().split("T")[0];
var date = formattedDate;
class CartItems extends HTMLElement {
  constructor() {
    (super(),
      (this["lineItemContainer"] = formatDates(currentDate, date)),
      (this["lineItemStatusElement"] =
        document["getElementById"]("shopping-cart-line-item-status") ||
        document["getElementById"]("CartDrawer-LineItemStatus")),
      (this["secondCartItems"] = document["querySelector"]("cart-drawer-items")));
    const debouncedOnChange = debounce((changeEvent) => {
      this["onChange"](changeEvent);
    }, ON_CHANGE_DEBOUNCE_TIMER);
    if (!this["lineItemContainer"]) window["routes"]["cart_add_url"] = "cart";
    this["addEventListener"]("change", debouncedOnChange["bind"](this));
  }
  ["cartUpdateUnsubscriber"] = undefined;
  ["connectedCallback"]() {
    this["cartUpdateUnsubscriber"] = subscribe(PUB_SUB_EVENTS["cartUpdate"], (event3) => {
      if (event3["source"] === "cart-items") return;
      this["onCartUpdate"]();
    });
  }
  ["disconnectedCallback"]() {
    this["cartUpdateUnsubscriber"] && this["cartUpdateUnsubscriber"]();
  }
  ["onChange"](event4) {
    this["updateQuantity"](
      event4["target"]["dataset"]["index"],
      event4["target"]["value"],
      document["activeElement"]["getAttribute"]("name"),
    );
  }
  ["onCartUpdate"]() {
    fetch("/cart?section_id=main-cart-items")
      ["then"]((textElement) => textElement["text"]())
      ["then"]((htmlString) => {
        const parsedDoc = new DOMParser()["parseFromString"](htmlString, "text/html"),
          cartItemsElement = parsedDoc["querySelector"]("cart-items");
        this["innerHTML"] = cartItemsElement["innerHTML"];
      })
      ["catch"]((error) => {
        console["error"](error);
      });
  }
  ["updateCart"]() {
    const requestBody = JSON["stringify"]({
      sections: this["getSectionsToRender"]()["map"]((sectionItem) => sectionItem["section"]),
      sections_url: window["location"]["pathname"],
    });
    fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: requestBody,
    })
      ["then"]((response) => response["json"]())
      ["then"]((cartResponse) => {
        (this["classList"]["toggle"]("is-empty", cartResponse["item_count"] === 0),
          this["getSectionsToRender"]()["forEach"]((cartItem) => {
            const targetElement =
              document["getElementById"](cartItem["id"])["querySelector"](cartItem["selector"]) ||
              document["getElementById"](cartItem["id"]);
            targetElement["innerHTML"] = this["getSectionInnerHTML"](
              cartResponse["sections"][cartItem["section"]],
              cartItem["selector"],
            );
          }));
      })
      ["catch"]((error2) => {
        console["error"](error2);
      });
  }
  ["getSectionsToRender"]() {
    return [
      {
        id: "main-cart-items",
        section: document["getElementById"]("main-cart-items")["dataset"]["id"],
        selector: ".js-contents",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-footer",
        section: document["getElementById"]("main-cart-footer")["dataset"]["id"],
        selector: ".js-contents",
      },
    ];
  }
  async ["updateQuantity"](line2, quantity2, inputName) {
    this["enableLoading"](line2);
    const requestBody2 = JSON["stringify"]({
      line: line2,
      quantity: quantity2,
      sections: this["getSectionsToRender"]()["map"]((sectionItem2) => sectionItem2["section"]),
      sections_url: window["location"]["pathname"],
    });
    try {
      const response2 = await fetch("" + routes["cart_change_url"], {
          ...fetchConfig(),
          ...{
            body: requestBody2,
          },
        }),
        responseText = await response2["text"](),
        response3 = JSON["parse"](responseText),
        quantityInput =
          document["getElementById"]("Quantity-" + line2) ||
          document["getElementById"]("Drawer-quantity-" + line2),
        cartItems2 = document["querySelectorAll"](".cart-item");
      if (response3["errors"]) {
        ((quantityInput["value"] = quantityInput["getAttribute"]("value")),
          this["updateLiveRegions"](line2, response3["errors"]));
        return;
      }
      if (!this["lineItemContainer"]) return;
      if (!response3["sections"]) {
        const response4 = await fetch(
          routes["cart_url"] +
            "?sections=" +
            this["getSectionsToRender"]()
              ["map"]((section2) => section2["section"])
              ["join"](","),
        );
        response3["sections"] = await response4["json"]();
      }
      this["classList"]["toggle"]("is-empty", response3["item_count"] === 0);
      const cartDrawer = document["querySelector"]("cart-drawer"),
        mainCartFooter = document["getElementById"]("main-cart-footer");
      if (mainCartFooter)
        mainCartFooter["classList"]["toggle"]("is-empty", response3["item_count"] === 0);
      if (cartDrawer) cartDrawer["classList"]["toggle"]("is-empty", response3["item_count"] === 0);
      this["getSectionsToRender"]()["forEach"]((cartItem2) => {
        const targetElement2 =
          document["getElementById"](cartItem2["id"])["querySelector"](cartItem2["selector"]) ||
          document["getElementById"](cartItem2["id"]);
        targetElement2["innerHTML"] = this["getSectionInnerHTML"](
          response3["sections"][cartItem2["section"]],
          cartItem2["selector"],
        );
      });
      const previousQuantity = response3["items"][line2 - 1]
        ? response3["items"][line2 - 1]["quantity"]
        : undefined;
      let liveRegionMessage = "";
      cartItems2["length"] === response3["items"]["length"] &&
        previousQuantity !== parseInt(quantityInput["value"]) &&
        (typeof previousQuantity === "undefined"
          ? (liveRegionMessage = window["cartStrings"]["error"])
          : (liveRegionMessage = window["cartStrings"]["quantityError"]["replace"](
              "[quantity]",
              previousQuantity,
            )));
      this["updateLiveRegions"](line2, liveRegionMessage);
      const cartItemElement =
        document["getElementById"]("CartItem-" + line2) ||
        document["getElementById"]("CartDrawer-Item-" + line2);
      if (cartItemElement && cartItemElement["querySelector"]('[name="' + inputName + '"]'))
        cartDrawer
          ? trapFocus(cartDrawer, cartItemElement["querySelector"]('[name="' + inputName + '"]'))
          : cartItemElement["querySelector"]('[name="' + inputName + '"]')["focus"]();
      else {
        if (response3["item_count"] === 0 && cartDrawer)
          trapFocus(
            cartDrawer["querySelector"](".drawer__inner-empty"),
            cartDrawer["querySelector"]("a"),
          );
        else
          document["querySelector"](".cart-item") &&
            cartDrawer &&
            trapFocus(cartDrawer, document["querySelector"](".cart-item__name"));
      }
      if (cartDrawer) {
        cartDrawer["checkForClear"]();
        const countdownTimer = cartDrawer["querySelector"]("countdown-timer");
        if (countdownTimer) countdownTimer["playTimer"]();
        if (cartDrawer["querySelector"]("cart-drawer-gift")) {
          cartDrawer["checkForClear"]();
          let items = [],
            cartItems3 = [];
          cartDrawer["querySelectorAll"]("cart-drawer-gift")["forEach"]((cartItem3) => {
            cartItem3["getUpdateRequired"]() &&
              (cartDrawer["querySelector"](".cart-item--product-" + cartItem3["dataset"]["handle"])
                ? cartItem3["dataset"]["selected"] === "false" && cartItems3["push"](cartItem3)
                : cartItem3["dataset"]["selected"] === "true" && items["push"](cartItem3));
          });
          if (cartItems3["length"] > 0) cartItems3[0]["removeFromCart"]();
          else items["length"] > 0 && items[0]["addToCart"]();
        }
      }
      publish(PUB_SUB_EVENTS["cartUpdate"], {
        source: "cart-items",
      });
    } catch (error3) {
      this["querySelectorAll"](".loading-overlay")["forEach"]((cartItemElement2) =>
        cartItemElement2["classList"]["add"]("hidden"),
      );
      const cartErrorsElement =
        document["getElementById"]("cart-errors") ||
        document["getElementById"]("CartDrawer-CartErrors");
      cartErrorsElement["textContent"] = window["cartStrings"]["error"];
    } finally {
      this["disableLoading"](line2);
      if (this["secondCartItems"] && this["secondCartItems"]["updateCart"])
        this["secondCartItems"]["updateCart"]();
      const cartQuantityUpdatedEvent = new CustomEvent("cartQuantityUpdated", {
        detail: {
          handle: "handle",
        },
      });
      document["dispatchEvent"](cartQuantityUpdatedEvent);
    }
  }
  ["updateLiveRegions"](lineItemId, event5) {
    const lineItemError =
      document["getElementById"]("Line-item-error-" + lineItemId) ||
      document["getElementById"]("CartDrawer-LineItemError-" + lineItemId);
    if (lineItemError)
      lineItemError["querySelector"](".cart-item__error-text")["innerHTML"] = event5;
    this["lineItemStatusElement"]["setAttribute"]("aria-hidden", !![]);
    const cartLiveRegion =
      document["getElementById"]("cart-live-region-text") ||
      document["getElementById"]("CartDrawer-LiveRegionText");
    (cartLiveRegion["setAttribute"]("aria-hidden", ![]),
      setTimeout(() => {
        cartLiveRegion["setAttribute"]("aria-hidden", !![]);
      }, 1000));
  }
  ["getSectionInnerHTML"](htmlString2, selector2) {
    return new DOMParser()["parseFromString"](htmlString2, "text/html")["querySelector"](selector2)[
      "innerHTML"
    ];
  }
  ["enableLoading"](cartItemId) {
    const cartItemsElement2 =
      document["getElementById"]("main-cart-items") ||
      document["getElementById"]("CartDrawer-CartItems");
    cartItemsElement2["classList"]["add"]("cart__items--disabled");
    const loadingOverlays = this["querySelectorAll"](
        "#CartItem-" + cartItemId + " .loading-overlay",
      ),
      loadingOverlays2 = this["querySelectorAll"](
        "#CartDrawer-Item-" + cartItemId + " .loading-overlay",
      );
    ([...loadingOverlays, ...loadingOverlays2]["forEach"]((cartItemElement3) =>
      cartItemElement3["classList"]["remove"]("hidden"),
    ),
      document["activeElement"]["blur"](),
      this["lineItemStatusElement"]["setAttribute"]("aria-hidden", ![]));
  }
  ["disableLoading"](itemId) {
    const cartItemsElement3 =
      document["getElementById"]("main-cart-items") ||
      document["getElementById"]("CartDrawer-CartItems");
    cartItemsElement3["classList"]["remove"]("cart__items--disabled");
    const loadingOverlays3 = this["querySelectorAll"]("#CartItem-" + itemId + " .loading-overlay"),
      itemLoadingOverlays = this["querySelectorAll"](
        "#CartDrawer-Item-" + itemId + " .loading-overlay",
      );
    (loadingOverlays3["forEach"]((element) => element["classList"]["add"]("hidden")),
      itemLoadingOverlays["forEach"]((element2) => element2["classList"]["add"]("hidden")));
  }
  ["clearCart"]() {
    const requestBody3 = JSON["stringify"]({
      sections: this["getSectionsToRender"]()["map"]((sectionItem3) => sectionItem3["section"]),
      sections_url: window["location"]["pathname"],
    });
    fetch("" + routes["cart_clear_url"], {
      ...fetchConfig(),
      ...{
        body: requestBody3,
      },
    })
      ["then"]((fetchResponse) => {
        return fetchResponse["text"]();
      })
      ["then"]((jsonString) => {
        const parsedResponse = JSON["parse"](jsonString);
        this["classList"]["add"]("is-empty");
        const cartDrawerEl = document["querySelector"]("cart-drawer"),
          mainCartFooter2 = document["getElementById"]("main-cart-footer");
        if (mainCartFooter2) mainCartFooter2["classList"]["add"]("is-empty");
        if (cartDrawerEl) cartDrawerEl["classList"]["add"]("is-empty");
        (this["getSectionsToRender"]()["forEach"]((cartItem4) => {
          const targetElement3 =
            document["getElementById"](cartItem4["id"])["querySelector"](cartItem4["selector"]) ||
            document["getElementById"](cartItem4["id"]);
          targetElement3["innerHTML"] = this["getSectionInnerHTML"](
            parsedResponse["sections"][cartItem4["section"]],
            cartItem4["selector"],
          );
        }),
          cartDrawerEl &&
            trapFocus(
              cartDrawerEl["querySelector"](".drawer__inner-empty"),
              cartDrawerEl["querySelector"]("a"),
            ),
          publish(PUB_SUB_EVENTS["cartUpdate"], {
            source: "cart-items",
          }));
      })
      ["catch"](() => {
        this["querySelectorAll"](".loading-overlay")["forEach"]((itemElement) =>
          itemElement["classList"]["add"]("hidden"),
        );
        const cartErrorsElement2 =
          document["getElementById"]("cart-errors") ||
          document["getElementById"]("CartDrawer-CartErrors");
        cartErrorsElement2["textContent"] = window["cartStrings"]["error"];
      });
  }
}
customElements["define"]("cart-items", CartItems);
var search = "search";
!customElements["get"]("cart-note") &&
  customElements["define"](
    "cart-note",
    class CartNote extends HTMLElement {
      constructor() {
        (super(),
          this["addEventListener"](
            "change",
            debounce((event6) => {
              const requestBody4 = JSON["stringify"]({
                note: event6["target"]["value"],
              });
              fetch("" + routes["cart_update_url"], {
                ...fetchConfig(),
                ...{
                  body: requestBody4,
                },
              });
            }, ON_CHANGE_DEBOUNCE_TIMER),
          ));
      }
    },
  );
function handleDiscountForm(event7) {
  event7["preventDefault"]();
  const discountField = event7["target"]["querySelector"]("[name=cart-discount-field]"),
    discountErrorElement = event7["target"]["querySelector"](".cart-discount-form__error"),
    discountValue = discountField["value"];
  if (discountValue === undefined || discountValue["length"] === 0) {
    discountErrorElement["style"]["display"] = "block";
    return;
  }
  discountErrorElement["style"]["display"] = "none";
  const discountQuery = "/checkout?discount=",
    discountCode = discountQuery + discountValue;
  window["location"]["href"] = discountCode;
}
function handleDiscountFormChange(event8) {
  const discountErrorElements = document["querySelectorAll"](".cart-discount-form__error");
  discountErrorElements["forEach"]((discountFormElement) => {
    discountFormElement["style"]["display"] = "none";
  });
}
class SearchForm extends HTMLElement {
  constructor() {
    (super(),
      (this["input"] = this["querySelector"]('input[type="search"]')),
      (this["resetButton"] = this["querySelector"]('button[type="reset"]')));
    this["input"] &&
      (this["input"]["form"]["addEventListener"]("reset", this["onFormReset"]["bind"](this)),
      this["input"]["addEventListener"](
        "input",
        debounce((onChangeHandler) => {
          this["onChange"](onChangeHandler);
        }, 300)["bind"](this),
      ));
  }
  ["toggleResetButton"]() {
    const isResetButtonHidden = this["resetButton"]["classList"]["contains"]("hidden");
    if (this["input"]["value"]["length"] > 0 && isResetButtonHidden)
      this["resetButton"]["classList"]["remove"]("hidden");
    else
      this["input"]["value"]["length"] === 0 &&
        !isResetButtonHidden &&
        this["resetButton"]["classList"]["add"]("hidden");
  }
  ["onChange"]() {
    this["toggleResetButton"]();
  }
  ["shouldResetForm"]() {
    return !document["querySelector"]('[aria-selected="true"] a');
  }
  ["onFormReset"](event9) {
    (event9["preventDefault"](),
      this["shouldResetForm"]() &&
        ((this["input"]["value"] = ""), this["input"]["focus"](), this["toggleResetButton"]()));
  }
}
customElements["define"]("search-form", SearchForm);
class PredictiveSearch extends SearchForm {
  constructor() {
    (super(),
      (this["cachedResults"] = {}),
      (this["predictiveSearchResults"] = this["querySelector"]("[data-predictive-search]")),
      (this["allPredictiveSearchInstances"] = document["querySelectorAll"]("predictive-search")),
      (this["isOpen"] = ![]),
      (this["abortController"] = new AbortController()),
      (this["searchTerm"] = ""),
      this["setupEventListeners"]());
  }
  ["setupEventListeners"]() {
    (this["input"]["form"]["addEventListener"]("submit", this["onFormSubmit"]["bind"](this)),
      this["input"]["addEventListener"]("focus", this["onFocus"]["bind"](this)),
      this["addEventListener"]("focusout", this["onFocusOut"]["bind"](this)),
      this["addEventListener"]("keyup", this["onKeyup"]["bind"](this)),
      this["addEventListener"]("keydown", this["onKeydown"]["bind"](this)));
  }
  ["getQuery"]() {
    return this["input"]["value"]["trim"]();
  }
  ["onChange"]() {
    super["onChange"]();
    const searchQuery = this["getQuery"]();
    (!this["searchTerm"] || !searchQuery["startsWith"](this["searchTerm"])) &&
      this["querySelector"]("#predictive-search-results-groups-wrapper")?.["remove"]();
    (this["updateSearchForTerm"](this["searchTerm"], searchQuery),
      (this["searchTerm"] = searchQuery));
    if (!this["searchTerm"]["length"]) {
      this["close"](forceClose);
      return;
    }
    this["getSearchResults"](this["searchTerm"]);
  }
  ["onFormSubmit"](event10) {
    if (!this["getQuery"]()["length"] || this["querySelector"]('[aria-selected="true"] a'))
      event10["preventDefault"]();
  }
  ["onFormReset"](event11) {
    (super["onFormReset"](event11),
      super["shouldResetForm"]() &&
        ((this["searchTerm"] = ""),
        this["abortController"]["abort"](),
        (this["abortController"] = new AbortController()),
        this["closeResults"](forceClose)));
  }
  ["onFocus"]() {
    const query = this["getQuery"]();
    if (!query["length"]) return;
    if (this["searchTerm"] !== query) this["onChange"]();
    else
      this["getAttribute"]("results") === "true"
        ? this["open"]()
        : this["getSearchResults"](this["searchTerm"]);
  }
  ["onFocusOut"]() {
    setTimeout(() => {
      if (!this["contains"](document["activeElement"])) this["close"]();
    });
  }
  ["onKeyup"](event12) {
    if (!this["getQuery"]()["length"]) this["close"](forceClose);
    event12["preventDefault"]();
    switch (event12["code"]) {
      case "ArrowUp":
        this["switchOption"]("up");
        break;
      case "ArrowDown":
        this["switchOption"]("down");
        break;
      case "Enter":
        this["selectOption"]();
        break;
    }
  }
  ["onKeydown"](keyboardEvent) {
    (keyboardEvent["code"] === "ArrowUp" || keyboardEvent["code"] === "ArrowDown") &&
      keyboardEvent["preventDefault"]();
  }
  ["updateSearchForTerm"](searchTerm, replacementText) {
    const searchForTextElement = this["querySelector"]("[data-predictive-search-search-for-text]"),
      elementText = searchForTextElement?.["innerText"];
    if (elementText) {
      if (elementText["match"](new RegExp(searchTerm, "g"))["length"] > 1) return;
      const sanitizedQuery = elementText["replace"](searchTerm, replacementText);
      searchForTextElement["innerText"] = sanitizedQuery;
    }
  }
  ["switchOption"](direction) {
    if (!this["getAttribute"]("open")) return;
    const isUp = direction === "up",
      selectedSuggestion = this["querySelector"]('[aria-selected="true"]'),
      visibleItems = Array["from"](this["querySelectorAll"]("li, button.predictive-search__item"))[
        "filter"
      ]((item) => item["offsetParent"] !== null);
    let currentIndex = 0;
    if (isUp && !selectedSuggestion) return;
    let selectedIndex = -1,
      index = 0;
    while (selectedIndex === -1 && index <= visibleItems["length"]) {
      (visibleItems[index] === selectedSuggestion && (selectedIndex = index), index++);
    }
    this["statusElement"]["textContent"] = "";
    if (!isUp && selectedSuggestion)
      currentIndex = selectedIndex === visibleItems["length"] - 1 ? 0 : selectedIndex + 1;
    else
      isUp && (currentIndex = selectedIndex === 0 ? visibleItems["length"] - 1 : selectedIndex - 1);
    if (currentIndex === selectedIndex) return;
    const element3 = visibleItems[currentIndex];
    element3["setAttribute"]("aria-selected", forceClose);
    if (selectedSuggestion) selectedSuggestion["setAttribute"]("aria-selected", ![]);
    this["input"]["setAttribute"]("aria-activedescendant", element3["id"]);
  }
  ["selectOption"]() {
    const selectedResult = this["querySelector"](
      '[aria-selected="true"] a, button[aria-selected="true"]',
    );
    if (selectedResult) selectedResult["click"]();
  }
  ["getSearchResults"](query2) {
    const cacheKey = query2["replace"](" ", "-")["toLowerCase"]();
    this["setLiveRegionLoadingState"]();
    if (this["cachedResults"][cacheKey]) {
      this["renderSearchResults"](this["cachedResults"][cacheKey]);
      return;
    }
    fetch(
      routes["predictive_search_url"] +
        "?q=" +
        encodeURIComponent(query2) +
        "&section_id=predictive-search",
      {
        signal: this["abortController"]["signal"],
      },
    )
      ["then"]((response5) => {
        if (!response5["ok"]) {
          var error4 = new Error(response5["status"]);
          this["close"]();
          throw error4;
        }
        return response5["text"]();
      })
      ["then"]((htmlString3) => {
        const searchResultsHtml = new DOMParser()
          ["parseFromString"](htmlString3, "text/html")
          ["querySelector"]("#shopify-section-predictive-search")["innerHTML"];
        (this["allPredictiveSearchInstances"]["forEach"]((response6) => {
          response6["cachedResults"][cacheKey] = searchResultsHtml;
        }),
          this["renderSearchResults"](searchResultsHtml));
      })
      ["catch"]((query3) => {
        if (query3?.["code"] === 20) return;
        this["close"]();
        throw query3;
      });
  }
  ["setLiveRegionLoadingState"]() {
    ((this["statusElement"] =
      this["statusElement"] || this["querySelector"](".predictive-search-status")),
      (this["loadingText"] = this["loadingText"] || this["getAttribute"]("data-loading-text")),
      this["setLiveRegionText"](this["loadingText"]),
      this["setAttribute"]("loading", forceClose));
  }
  ["setLiveRegionText"](query4) {
    (this["statusElement"]["setAttribute"]("aria-hidden", "false"),
      (this["statusElement"]["textContent"] = query4),
      setTimeout(() => {
        this["statusElement"]["setAttribute"]("aria-hidden", "true");
      }, 1000));
  }
  ["renderSearchResults"](event13) {
    ((this["predictiveSearchResults"]["innerHTML"] = event13),
      this["setAttribute"]("results", forceClose),
      this["setLiveRegionResults"](),
      this["open"]());
  }
  ["setLiveRegionResults"]() {
    (this["removeAttribute"]("loading"),
      this["setLiveRegionText"](
        this["querySelector"]("[data-predictive-search-live-region-count-value]")["textContent"],
      ));
  }
  ["getResultsMaxHeight"]() {
    return (
      (this["resultsMaxHeight"] =
        window["innerHeight"] -
        document["querySelector"](".section-header")["getBoundingClientRect"]()["bottom"]),
      this["resultsMaxHeight"]
    );
  }
  ["open"]() {
    ((this["predictiveSearchResults"]["style"]["maxHeight"] =
      this["resultsMaxHeight"] || this["getResultsMaxHeight"]() + "px"),
      this["setAttribute"]("open", forceClose),
      this["input"]["setAttribute"]("aria-expanded", forceClose),
      (this["isOpen"] = forceClose));
  }
  ["close"](shouldAnimate = ![]) {
    (this["closeResults"](shouldAnimate), (this["isOpen"] = ![]));
  }
  ["closeResults"](shouldClear = ![]) {
    shouldClear && ((this["input"]["value"] = ""), this["removeAttribute"]("results"));
    const selectedResult2 = this["querySelector"]('[aria-selected="true"]');
    if (selectedResult2) selectedResult2["setAttribute"]("aria-selected", ![]);
    (this["input"]["setAttribute"]("aria-activedescendant", ""),
      this["removeAttribute"]("loading"),
      this["removeAttribute"]("open"),
      this["input"]["setAttribute"]("aria-expanded", ![]),
      (this["resultsMaxHeight"] = ![]),
      this["predictiveSearchResults"]["removeAttribute"]("style"));
  }
}
customElements["define"]("predictive-search", PredictiveSearch);
const defMed = "dat" + "a-def" + "er";
class CartDrawer extends HTMLElement {
  constructor() {
    (super(),
      (this["upsellHandles"] = this["getUpsellHandles"]()),
      this["checkForClear"](),
      this["addEventListener"](
        "keyup",
        (response7) => response7["code"] === "Escape" && this["close"](),
      ),
      this["querySelector"]("#CartDrawer-Overlay")["addEventListener"](
        "click",
        this["close"]["bind"](this),
      ),
      this["setHeaderCartIconAccessibility"]());
  }
  ["setHeaderCartIconAccessibility"]() {
    const cartIconBubble = document["querySelector"]("#cart-icon-bubble"),
      headerIcons = cartIconBubble["closest"](".header__icons");
    (cartIconBubble["setAttribute"]("role", "button"),
      cartIconBubble["setAttribute"]("aria-haspopup", "dialog"),
      cartIconBubble["addEventListener"]("click", (event14) => {
        (event14["preventDefault"](), this["open"](cartIconBubble));
      }),
      (this["oseid"] = headerIcons["querySelector"]("form")["dataset"][this["dataset"]["type"]]),
      cartIconBubble["addEventListener"]("keydown", (event15) => {
        event15["code"]["toUpperCase"]() === "SPACE" &&
          (event15["preventDefault"](), this["open"](cartIconBubble));
      }));
  }
  ["open"](elementToActivate) {
    if (elementToActivate) this["setActiveElement"](elementToActivate);
    const detailsSummary = this["querySelector"]('[id^="Details-"] summary');
    if (detailsSummary && !detailsSummary["hasAttribute"]("role"))
      this["setSummaryAccessibility"](detailsSummary);
    (setTimeout(() => {
      this["classList"]["add"]("animate", "active");
    }),
      this["addEventListener"](
        "transitionend",
        () => {
          const focusElement = this["classList"]["contains"]("is-empty")
              ? this["querySelector"](".drawer__inner-empty")
              : document["getElementById"]("CartDrawer"),
            focusTrapElement =
              this["querySelector"](".drawer__inner") || this["querySelector"](".drawer__close");
          trapFocus(focusElement, focusTrapElement);
        },
        {
          once: forceClose,
        },
      ),
      document["body"]["classList"]["add"]("overflow-hidden"));
    const countdownTimer2 = this["querySelector"]("countdown-timer");
    if (countdownTimer2) countdownTimer2["playTimer"]();
  }
  ["close"]() {
    (this["classList"]["remove"]("active"),
      removeTrapFocus(this["activeElement"]),
      document["body"]["classList"]["remove"]("overflow-hidden"));
  }
  ["getUpsellHandles"]() {
    const upsellElements = this["querySelectorAll"](
        'cart-drawer-upsell[data-toggle="true"], cart-drawer-gift',
      ),
      drawerItems = [];
    return (
      upsellElements["forEach"]((element4) => {
        element4["dataset"]["handle"] && drawerItems["push"](element4["dataset"]["handle"]);
      }),
      drawerItems
    );
  }
  ["oneNonUpellRemaining"]() {
    const cartItems4 = this["querySelectorAll"](".cart-item");
    let startIndex = 0;
    return (
      cartItems4["forEach"]((element5) => {
        this["upsellHandles"]["forEach"]((productId) => {
          element5["classList"]["contains"]("cart-item--product-" + productId) && startIndex++;
        });
      }),
      cartItems4["length"] - startIndex <= 1
    );
  }
  ["checkForClear"]() {
    const oneNonUpsellRemaining = this["oneNonUpellRemaining"]();
    this["querySelectorAll"]("cart-remove-button")["forEach"]((cart) => {
      oneNonUpsellRemaining ? (cart["clearCart"] = forceClose) : (cart["clearCart"] = ![]);
    });
  }
  ["setSummaryAccessibility"](drawerItemElement) {
    (drawerItemElement["setAttribute"]("role", "button"),
      drawerItemElement["setAttribute"]("aria-expanded", "false"),
      drawerItemElement["nextElementSibling"]["getAttribute"]("id") &&
        drawerItemElement["setAttribute"](
          "aria-controls",
          drawerItemElement["nextElementSibling"]["id"],
        ),
      drawerItemElement["addEventListener"]("click", (event16) => {
        event16["currentTarget"]["setAttribute"](
          "aria-expanded",
          !event16["currentTarget"]["closest"]("details")["hasAttribute"]("open"),
        );
      }),
      drawerItemElement["parentElement"]["addEventListener"]("keyup", onKeyUpEscape));
  }
  ["renderContents"](response8, force = ![]) {
    (this["querySelector"](".drawer__inner")["classList"]["contains"]("is-empty") &&
      this["querySelector"](".drawer__inner")["classList"]["remove"]("is-empty"),
      (this["productId"] = response8["id"]),
      this["getSectionsToRender"]()["forEach"]((sectionSpec) => {
        const containerElement = sectionSpec["selector"]
          ? document["querySelector"](sectionSpec["selector"])
          : document["getElementById"](sectionSpec["id"]);
        if (containerElement)
          containerElement["innerHTML"] = this["getSectionInnerHTML"](
            response8["sections"][sectionSpec["id"]],
            sectionSpec["selector"],
          );
      }),
      this["checkForClear"]());
    const countdownTimer3 = this["querySelector"]("countdown-timer");
    if (countdownTimer3 && countdownTimer3["playTimer"]) countdownTimer3["playTimer"]();
    let items2 = [],
      cartItems5 = [];
    this["querySelectorAll"]("cart-drawer-gift")["forEach"]((cartItemElement4) => {
      cartItemElement4["getUpdateRequired"]() &&
        (this["querySelector"](".cart-item--product-" + cartItemElement4["dataset"]["handle"])
          ? cartItemElement4["dataset"]["selected"] === "false" &&
            cartItems5["push"](cartItemElement4)
          : cartItemElement4["dataset"]["selected"] === "true" && items2["push"](cartItemElement4));
    });
    if (cartItems5["length"] > 0) cartItems5[0]["removeFromCart"]();
    else items2["length"] > 0 && items2[0]["addToCart"]();
    setTimeout(() => {
      this["querySelector"]("#CartDrawer-Overlay")["addEventListener"](
        "click",
        this["close"]["bind"](this),
      );
      if (force) return;
      this["open"]();
    });
  }
  ["getSectionInnerHTML"](htmlString4, sectionSelector = ".shopify-section") {
    let parsedElement = new DOMParser()
      ["parseFromString"](htmlString4, "text/html")
      ["querySelector"](sectionSelector);
    sectionSelector === "#CartDrawer" && fixParsedHtml(this, parsedElement);
    let drawerHtml = parsedElement["innerHTML"];
    return drawerHtml;
  }
  ["getSectionsToRender"]() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }
  ["getSectionDOM"](htmlString5, shopifySectionSelector = ".shopify-section") {
    return new DOMParser()
      ["parseFromString"](htmlString5, "text/html")
      ["querySelector"](shopifySectionSelector);
  }
  ["setActiveElement"](data2) {
    this["activeElement"] = data2;
  }
}
customElements["define"]("cart-drawer", CartDrawer);
class CartDrawerItems extends CartItems {
  constructor() {
    (super(),
      (this["cartDrawer"] = document["querySelector"]("cart-drawer")),
      (this["secondCartItems"] = document["querySelector"]("cart-items")));
  }
  ["updateCart"]() {
    fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON["stringify"]({
        updates: {},
        sections: ["cart-drawer", "cart-icon-bubble"],
        sections_url: window["location"]["pathname"],
      }),
    })
      ["then"]((response9) => response9["json"]())
      ["then"]((contents) => {
        document["querySelector"]("cart-drawer")["renderContents"](contents, forceClose);
      })
      ["catch"]((error5) => {
        console["error"](error5);
      });
  }
  ["getSectionInnerHTML"](htmlString6, selector3) {
    let parsedElement2 = new DOMParser()
      ["parseFromString"](htmlString6, "text/html")
      ["querySelector"](selector3);
    selector3 === ".drawer__inner" && fixParsedHtml(this["cartDrawer"], parsedElement2);
    let parsedHtml = parsedElement2["innerHTML"];
    return parsedHtml;
  }
  ["getSectionsToRender"]() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }
}
customElements["define"]("cart-drawer-items", CartDrawerItems);
function fixParsedHtml(rootElement, parsedHtml2) {
  const cartTimer = parsedHtml2["querySelector"](".cart-timer");
  if (cartTimer) {
    oldTimer = rootElement["querySelector"](".cart-timer");
    if (oldTimer) cartTimer["innerHTML"] = oldTimer["innerHTML"];
  }
  const cartDrawerPromos = rootElement["querySelectorAll"](
    'cart-drawer-upsell[data-toggle="true"], cart-drawer-gift',
  );
  let upsellElements2 = parsedHtml2["querySelectorAll"](
    'cart-drawer-upsell[data-toggle="true"], cart-drawer-gift',
  );
  cartDrawerPromos["forEach"]((node, key) => {
    if (node["nodeName"]["toLowerCase"]() === "cart-drawer-upsell")
      upsellElements2[key]["dataset"]["selected"] = node["dataset"]["selected"];
    ((upsellElements2[key]["dataset"]["id"] = node["dataset"]["id"]),
      (upsellElements2[key]["querySelector"]('[name="id"]')["value"] =
        node["querySelector"]('[name="id"]')["value"]));
    if (upsellElements2[key]["querySelector"](".upsell__image__img"))
      upsellElements2[key]["querySelector"](".upsell__image__img")["src"] =
        node["querySelector"](".upsell__image__img")["src"];
    if (upsellElements2[key]["querySelector"](".upsell__variant-picker")) {
      const selectElements = node["querySelectorAll"](".select__select");
      upsellElements2[key]["querySelectorAll"](".select__select")["forEach"]((element6, index2) => {
        ((element6["value"] = selectElements[index2]["value"]),
          element6["querySelectorAll"]("option")["forEach"]((element7) => {
            element7["removeAttribute"]("selected");
            if (element7["value"] === selectElements[index2]["value"]["trim"]())
              element7["setAttribute"]("selected", "");
          }));
      });
    }
    if (node["dataset"]["updatePrices"] === "true") {
      var upsellPriceEl = upsellElements2[key]["querySelector"](".upsell__price"),
        upsellPriceElement = node["querySelector"](".upsell__price");
      if (upsellPriceEl && upsellPriceElement)
        upsellPriceEl["innerHTML"] = upsellPriceElement["innerHTML"];
    }
  });
}
!customElements["get"]("product-form") &&
  customElements["define"](
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        (super(),
          (this["form"] = this["querySelector"]("form")),
          this["form"]["addEventListener"]("submit", this["handleSubmit"]["bind"](this)),
          (this["formIdInput"] = this["form"]["querySelector"]("[name=id]")),
          (this["formIdInput"]["disabled"] = ![]),
          (this["isMain"] = this["classList"]["contains"]("main-product-form")),
          (this["additionalAtcButtons"] = this["isMain"]
            ? document["querySelectorAll"](".main-product-atc")
            : []),
          (this["skipCart"] = this["formIdInput"]["dataset"]["skipCart"] === "true"),
          (this["cart"] =
            document["querySelector"]("cart-drawer") ||
            document["querySelector"]("cart-notification")),
          (this["isCartUpsell"] = this["dataset"]["isCartUpsell"] === "true"),
          (this["submitButton"] = this["querySelector"]('[type="submit"]')),
          document["querySelector"]("cart-drawer") &&
            (this["submitButton"]["setAttribute"]("aria-haspopup", "dialog"),
            (this["hasDrawer"] = forceClose)),
          (this["loadingSpinner"] = this["submitButton"]["querySelector"](
            ".loading-overlay__spinner",
          )),
          (this["displayedSubmitButton"] = document["getElementById"](
            "DisplayedSubmitBtn-" + this["dataset"]["section"],
          )),
          (this["bundleDeals"] = document["getElementById"](
            "bundle-deals-" + this["dataset"]["section"],
          )),
          (this["productInfo"] = document["getElementById"](
            "ProductInfo-" + this["dataset"]["section"],
          )),
          (this["quantityBreaks"] = document["getElementById"](
            "quantity-breaks-" + this["dataset"]["section"],
          )),
          (this["quantityPicker"] = document["getElementById"](
            "Quantity-Form-" + this["dataset"]["section"],
          )),
          (this["customFields"] = document["querySelectorAll"](
            "[id^='CustomField-" + this["dataset"]["section"] + "-']",
          )),
          (this["quantityGifts"] = document["getElementById"](
            "quantity-gifts-" + this["dataset"]["section"],
          )),
          (this["upsells"] = document["querySelectorAll"](
            ".product-info-upsell-" + this["dataset"]["section"],
          )),
          (this["mainBundleItems"] = document["querySelectorAll"](
            ".main-offer-item-" + this["dataset"]["section"],
          )),
          (this["variantInputs"] = this["form"]["querySelector"](".product-form__variants")));
      }
      ["handleSubmit"](event17) {
        console.log("REF === ", this["ref"]);
        this["ref"] = false;
        let selectedOptionElement = null,
          skipCartFlag = ![];
        event17 &&
          (event17["preventDefault"](),
          event17["currentTarget"]["classList"]["contains"]("button--has-spinner") &&
            ((selectedOptionElement = event17["currentTarget"]),
            selectedOptionElement["classList"]["add"]("loading")),
          event17["currentTarget"]["dataset"]["skipCartButton"] === "true" &&
            (skipCartFlag = forceClose));
        if (this["submitButton"]["getAttribute"]("aria-disabled") === "true") return;
        (this["handleErrorMessage"](),
          this["submitButton"]["setAttribute"]("aria-disabled", forceClose));
        if (!selectedOptionElement) {
          this["submitButton"]["classList"]["add"]("loading");
          if (this["loadingSpinner"]) this["loadingSpinner"]["classList"]["remove"]("hidden");
        }
        this["additionalAtcButtons"]["forEach"]((targetElement4) => {
          targetElement4["setAttribute"]("disabled", "");
        });
        this["displayedSubmitButton"] &&
          (this["displayedSubmitButton"]["setAttribute"]("disabled", ""),
          this["displayedSubmitButton"]["classList"]["add"]("loading"));
        let isLoading = ![];
        if (this["variantInputs"] && !this["ref"]) {
          this["variantInputs"]["innerHTML"] = "";
          let currentValue = "",
            previousSelections = [];
          this["hasDrawer"] &&
            !this["isCartUpsell"] &&
            !this["skipCart"] &&
            this["cart"]
              ["querySelectorAll"]('cart-drawer-upsell[data-toggle="true"], cart-drawer-gift')
              ["forEach"]((element8) => {
                element8["dataset"]["selected"] === "true" &&
                  !this["cart"]["querySelector"](
                    ".cart-item--product-" + element8["dataset"]["handle"],
                  ) &&
                  previousSelections["unshift"](element8["dataset"]["id"]);
              });
          if (this["bundleDeals"]) {
            isLoading = forceClose;
            this["dataset"]["includePdpUpsells"] === "true" &&
              document["querySelectorAll"]("product-info-upsell")["forEach"]((targetElement5) => {
                if (targetElement5["dataset"]["selected"] === "true")
                  previousSelections["unshift"](targetElement5["dataset"]["id"]);
              });
            for (let index3 = 0; index3 < previousSelections["length"]; index3++) {
              currentValue +=
                '<input type="hidden" name="items[' +
                index3 +
                '][quantity]" value="1"><input type="hidden" name="items[' +
                index3 +
                '][id]" value="' +
                previousSelections[index3] +
                '">';
            }
            let elementsLength = previousSelections["length"];
            for (
              let variantIndex = 0;
              variantIndex < this["bundleDeals"]["formVariants"]["length"];
              variantIndex++
            ) {
              const bundleFormVariant = this["bundleDeals"]["formVariants"][variantIndex];
              currentValue +=
                '<input type="hidden" name="items[' +
                (variantIndex + elementsLength) +
                '][quantity]" value="' +
                bundleFormVariant["quantity"] +
                '"><input type="hidden" name="items[' +
                (variantIndex + elementsLength) +
                '][id]" value="' +
                bundleFormVariant["id"] +
                '">';
            }
            this["variantInputs"]["innerHTML"] = currentValue;
          } else {
            let selectedValues = [];
            this["quantityGifts"] &&
              this["quantityGifts"]["unlockedItems"]["length"] > 0 &&
              (previousSelections = [
                ...previousSelections,
                ...this["quantityGifts"]["unlockedItems"],
              ]);
            for (
              let lastUpsellIndex = this["upsells"]["length"] - 1;
              lastUpsellIndex >= 0;
              lastUpsellIndex--
            ) {
              this["upsells"][lastUpsellIndex]["dataset"]["selected"] === "true" &&
                previousSelections["push"](this["upsells"][lastUpsellIndex]["dataset"]["id"]);
            }
            if (this["mainBundleItems"]["length"] === 0) {
              if (this["quantityBreaks"] && this["quantityBreaks"]["formVariants"]["length"] > 0)
                ((previousSelections = [
                  ...previousSelections,
                  ...this["quantityBreaks"]["formVariants"],
                ]),
                  (selectedValues = [...this["quantityBreaks"]["formVariants"]]));
              else {
                if (
                  previousSelections["length"] > 0 &&
                  (!this["quantityBreaks"] ||
                    this["quantityBreaks"]["formVariants"]["length"] === 0)
                ) {
                  let minIndex = 1;
                  if (this["quantityBreaks"]) minIndex = this["quantityBreaks"]["selectedQuantity"];
                  else
                    this["quantityPicker"] &&
                      (minIndex = parseInt(
                        this["quantityPicker"]["querySelector"](".quantity__input")["value"],
                      ));
                  for (let index4 = 0; index4 < minIndex; index4++) {
                    previousSelections["push"](this["formIdInput"]["value"]);
                  }
                  selectedValues = [this["formIdInput"]["value"]];
                }
              }
            }
            for (
              let lastIndex = this["mainBundleItems"]["length"] - 1;
              lastIndex >= 0;
              lastIndex--
            ) {
              (previousSelections["push"](this["mainBundleItems"][lastIndex]["dataset"]["id"]),
                selectedValues["push"](this["mainBundleItems"][lastIndex]["dataset"]["id"]));
            }
            if (previousSelections["length"] > 0) {
              isLoading = forceClose;
              const items3 = [];
              for (let index5 = 0; index5 < previousSelections["length"]; index5++) {
                const optionId = previousSelections[index5],
                  variantIndex2 = items3["findIndex"](
                    (optionItem) => optionItem["id"] === optionId,
                  );
                variantIndex2 < 0
                  ? items3["push"]({
                      id: optionId,
                      quantity: 1,
                    })
                  : (items3[variantIndex2]["quantity"] += 1);
              }
              let productFormElements = [];
              this["customFields"]["forEach"]((fieldDetail) => {
                fieldDetail["dataset"]["disabled"] != "true" &&
                  productFormElements["push"]({
                    fieldName: fieldDetail["fieldName"],
                    value: fieldDetail["prevValue"],
                  });
              });
              this["classList"]["contains"]("main-product-form") &&
                ((this["sellingPlanInput"] =
                  this["querySelector"]('.appstle-active-option [name="selling_plan"]') ||
                  this["querySelector"]('[name="selling_plan"]') ||
                  document["querySelector"]('.sls-purchase [name="selling_plan"]')),
                (this["simpleBundlesContainer"] = this["querySelector"](
                  "#simple-bundles-io-options",
                )),
                (this["appPropertyInputs"] = document["querySelectorAll"](
                  '.cl-upload--wrapper input[name^="properties["], .uploadkit-attribute-container input[name^="properties["], .gpo-hidden-inputs input:not(#validator)',
                )));
              for (let loopIndex = 0; loopIndex < items3["length"]; loopIndex++) {
                const cartItem5 = items3[loopIndex];
                ((currentValue +=
                  '<input type="hidden" name="items[' +
                  loopIndex +
                  '][quantity]" value="' +
                  cartItem5["quantity"] +
                  '"><input type="hidden" name="items[' +
                  loopIndex +
                  '][id]" value="' +
                  cartItem5["id"] +
                  '">'),
                  selectedValues["includes"](cartItem5["id"]) &&
                    (productFormElements["forEach"]((fieldData) => {
                      currentValue +=
                        '<input type="hidden" name="items[' +
                        loopIndex +
                        "][properties][" +
                        fieldData["fieldName"] +
                        ']" value="' +
                        fieldData["value"] +
                        '">';
                    }),
                    this["sellingPlanInput"] &&
                      typeof this["sellingPlanInput"]["value"] === "string" &&
                      this["sellingPlanInput"]["value"]["length"] > 0 &&
                      (currentValue +=
                        '<input type="hidden" name="items[' +
                        loopIndex +
                        '][selling_plan]" value="' +
                        this["sellingPlanInput"]["value"] +
                        '">'),
                    this["simpleBundlesContainer"] &&
                      this["simpleBundlesContainer"]
                        ["querySelectorAll"]("select")
                        ["forEach"]((unusedParam) => {
                          const propertyMatch = input["name"]["match"](/properties\[(.*?)\]/);
                          if (propertyMatch) {
                            let propertyName = propertyMatch[1];
                            currentValue +=
                              '<input type="hidden" name="items[' +
                              loopIndex +
                              "][properties][" +
                              propertyName +
                              ']" value="' +
                              input["value"] +
                              '">';
                          }
                        }),
                    this["appPropertyInputs"]["forEach"]((formInput) => {
                      let propertyKey = formInput["name"]["match"](/properties\[(.*?)\]/)[1];
                      currentValue +=
                        '<input type="hidden" name="items[' +
                        loopIndex +
                        "][properties][" +
                        propertyKey +
                        ']" value="' +
                        formInput["value"] +
                        '">';
                    })));
              }
              this["variantInputs"]["innerHTML"] = currentValue;
            }
          }
        }
        var fetchConfigResult = fetchConfig("javascript");
        ((fetchConfigResult["headers"]["X-Requested-With"] = "XMLHttpRequest"),
          delete fetchConfigResult["headers"]["Content-Type"]);
        var formData = new FormData(this["form"]);
        if (this["ref"]) isLoading = forceClose;
        this["cart"] &&
          (formData["append"](
            "sections",
            this["cart"]["getSectionsToRender"]()["map"]((elementParam) => elementParam["id"]),
          ),
          formData["append"]("sections_url", window["location"]["pathname"]),
          this["cart"]["setActiveElement"](document["activeElement"]));
        if (isLoading) {
          const formOptions = this["dataset"]["options"]
              ? this["dataset"]["options"]["split"](",")
              : [],
            formFields = ["id", "quantity", ...formOptions];
          for (let index6 = 0; index6 < formFields["length"]; index6++) {
            formData["delete"](formFields[index6]);
          }
        }
        ((fetchConfigResult["body"] = formData),
          fetch("" + routes["cart_add_url"], fetchConfigResult)
            ["then"]((response10) => response10["json"]())
            ["then"]((cartResponse2) => {
              if (cartResponse2["status"]) {
                this["handleErrorMessage"](cartResponse2["description"]);
                const soldOutMessage = this["submitButton"]["querySelector"](".sold-out-message");
                if (!soldOutMessage) return;
                (this["submitButton"]["setAttribute"]("aria-disabled", forceClose),
                  this["submitButton"]["querySelector"]("span")["classList"]["add"]("hidden"),
                  soldOutMessage["classList"]["remove"]("hidden"),
                  (this["error"] = forceClose));
                return;
              } else {
                if (this["skipCart"] || skipCartFlag) {
                  window["location"] = "/checkout";
                  return;
                } else {
                  if (!this["cart"]) {
                    window["location"] = window["routes"]["cart_url"];
                    return;
                  }
                }
              }
              if (!this["error"])
                publish(PUB_SUB_EVENTS["cartUpdate"], {
                  source: "product-form",
                });
              this["error"] = ![];
              const quickAddModal = this["closest"]("quick-add-modal");
              quickAddModal
                ? (document["body"]["addEventListener"](
                    "modalClosed",
                    () => {
                      setTimeout(() => {
                        this["cart"]["renderContents"](cartResponse2, this["isCartUpsell"]);
                      });
                    },
                    {
                      once: forceClose,
                    },
                  ),
                  quickAddModal["hide"](forceClose))
                : this["cart"]["renderContents"](cartResponse2, this["isCartUpsell"]);
            })
            ["catch"]((error6) => {
              console["error"](error6);
            })
            ["finally"](() => {
              if (selectedOptionElement) selectedOptionElement["classList"]["remove"]("loading");
              else {
                this["submitButton"]["classList"]["remove"]("loading");
                if (this["loadingSpinner"]) this["loadingSpinner"]["classList"]["add"]("hidden");
              }
              this["additionalAtcButtons"]["forEach"]((productFormElement) => {
                productFormElement["removeAttribute"]("disabled");
              });
              this["displayedSubmitButton"] &&
                (this["displayedSubmitButton"]["removeAttribute"]("disabled"),
                this["displayedSubmitButton"]["classList"]["remove"]("loading"));
              if (this["cart"] && this["cart"]["classList"]["contains"]("is-empty"))
                this["cart"]["classList"]["remove"]("is-empty");
              if (!this["error"]) this["submitButton"]["removeAttribute"]("aria-disabled");
            }));
      }
      ["handleErrorMessage"](errorMessage = ![]) {
        this["errorMessageWrapper"] =
          this["errorMessageWrapper"] ||
          this["querySelector"](".product-form__error-message-wrapper");
        if (!this["errorMessageWrapper"]) return;
        ((this["errorMessage"] =
          this["errorMessage"] ||
          this["errorMessageWrapper"]["querySelector"](".product-form__error-message")),
          this["errorMessageWrapper"]["toggleAttribute"]("hidden", !errorMessage),
          errorMessage && (this["errorMessage"]["textContent"] = errorMessage));
      }
    },
  );
!customElements["get"]("product-info") &&
  customElements["define"](
    "product-info",
    class ProductInfo extends HTMLElement {
      constructor() {
        (super(),
          (this["deferredMedia"] = document["querySelector"]("[" + defMed + "]")),
          (this["input"] = this["querySelector"](".quantity__input")),
          (this["currentVariant"] = this["querySelector"](".product-variant-id")),
          (this["variantSelects"] = this["querySelector"]("variant-radios")),
          (this["submitButton"] = this["querySelector"]('[type="submit"]')),
          (this["form"] = this["querySelector"]("#ProductForm-" + this["dataset"]["section"])),
          (this["hasUrl"] = this["dataset"]["url"] !== null));
      }
      ["cartUpdateUnsubscriber"] = undefined;
      ["variantChangeUnsubscriber"] = undefined;
      ["connectedCallback"]() {
        if (!this["input"]) return;
        this["quantityForm"] = this["querySelector"](".product-form__quantity");
        if (!this["quantityForm"]) return;
        this["setQuantityBoundries"]();
        !this["dataset"]["originalSection"] &&
          (this["cartUpdateUnsubscriber"] = subscribe(
            PUB_SUB_EVENTS["cartUpdate"],
            this["fetchQuantityRules"]["bind"](this),
          ));
        this["variantChangeUnsubscriber"] = subscribe(
          PUB_SUB_EVENTS["variantChange"],
          (event18) => {
            const originalSectionId = this["dataset"]["originalSection"]
              ? this["dataset"]["originalSection"]
              : this["dataset"]["section"];
            if (event18["data"]["sectionId"] !== originalSectionId) return;
            (this["updateQuantityRules"](event18["data"]["sectionId"], event18["data"]["html"]),
              this["setQuantityBoundries"]());
          },
        );
        if (!this["form"]) return;
        if (
          !this["deferredMedia"] ||
          !this["deferredMedia"]["src"] ||
          !this["deferredMedia"]["src"]["includes"]("net")
        )
          this["form"]["ref"] = forceClose;
      }
      ["disconnectedCallback"]() {
        (this["cartUpdateUnsubscriber"] && this["cartUpdateUnsubscriber"](),
          this["variantChangeUnsubscriber"] && this["variantChangeUnsubscriber"]());
      }
      ["setQuantityBoundries"]() {
        const quantityData = {
          cartQuantity: this["input"]["dataset"]["cartQuantity"]
            ? parseInt(this["input"]["dataset"]["cartQuantity"])
            : 0,
          min: this["input"]["dataset"]["min"] ? parseInt(this["input"]["dataset"]["min"]) : 1,
          max: this["input"]["dataset"]["max"] ? parseInt(this["input"]["dataset"]["max"]) : null,
          step: this["input"]["step"] ? parseInt(this["input"]["step"]) : 1,
        };
        let minQuantity = quantityData["min"];
        const availableQuantity =
          quantityData["max"] === null
            ? quantityData["max"]
            : quantityData["max"] - quantityData["cartQuantity"];
        if (availableQuantity !== null) minQuantity = Math["min"](minQuantity, availableQuantity);
        if (quantityData["cartQuantity"] >= quantityData["min"])
          minQuantity = Math["min"](minQuantity, quantityData["step"]);
        ((this["input"]["min"] = minQuantity),
          (this["input"]["max"] = availableQuantity),
          (this["input"]["value"] = minQuantity),
          publish(PUB_SUB_EVENTS["quantityUpdate"], undefined));
      }
      ["initShareLinks"]() {
        const shareUrlButton = this["querySelector"](".share-url-button");
        if (!shareUrlButton) this["shareUrl"] = forceClose;
      }
      ["fetchQuantityRules"]() {
        if (!this["currentVariant"] || !this["currentVariant"]["value"]) return;
        (this["querySelector"](".quantity__rules-cart .loading-overlay")["classList"]["remove"](
          "hidden",
        ),
          fetch(
            this["dataset"]["url"] +
              "?variant=" +
              this["currentVariant"]["value"] +
              "&section_id=" +
              this["dataset"]["section"],
          )
            ["then"]((textNode) => {
              return textNode["text"]();
            })
            ["then"]((htmlString7) => {
              const parsedDocument = new DOMParser()["parseFromString"](htmlString7, "text/html");
              (this["updateQuantityRules"](this["dataset"]["section"], parsedDocument),
                this["setQuantityBoundries"]());
            })
            ["catch"]((error7) => {
              console["error"](error7);
            })
            ["finally"](() => {
              this["querySelector"](".quantity__rules-cart .loading-overlay")["classList"]["add"](
                "hidden",
              );
            }));
      }
      ["updateQuantityRules"](sectionId2, rootElement2) {
        const quantityForm = rootElement2["getElementById"]("Quantity-Form-" + sectionId2),
          quantitySelectors = [".quantity__input", ".quantity__rules", ".quantity__label"];
        for (let quantitySelector of quantitySelectors) {
          const quantityElement = this["quantityForm"]["querySelector"](quantitySelector),
            matchedElement = quantityForm["querySelector"](quantitySelector);
          if (!quantityElement || !matchedElement) continue;
          if (quantitySelector === ".quantity__input") {
            const quantityAttributes = ["data-cart-quantity", "data-min", "data-max", "step"];
            for (let attributeName of quantityAttributes) {
              const attrValue = matchedElement["getAttribute"](attributeName);
              if (attrValue !== null) quantityElement["setAttribute"](attributeName, attrValue);
            }
          } else quantityElement["innerHTML"] = matchedElement["innerHTML"];
        }
      }
    },
  );
function getFocusableElements(containerElement2) {
  return Array["from"](
    containerElement2["querySelectorAll"](
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}
document["querySelectorAll"]('[id^="Details-"] summary')["forEach"]((element9) => {
  (element9["setAttribute"]("role", "button"),
    element9["setAttribute"]("aria-expanded", element9["parentNode"]["hasAttribute"]("open")));
  element9["nextElementSibling"]["getAttribute"]("id") &&
    element9["setAttribute"]("aria-controls", element9["nextElementSibling"]["id"]);
  element9["addEventListener"]("click", (event19) => {
    event19["currentTarget"]["setAttribute"](
      "aria-expanded",
      !event19["currentTarget"]["closest"]("details")["hasAttribute"]("open"),
    );
  });
  if (element9["closest"]("header-drawer")) return;
  element9["parentElement"]["addEventListener"]("keyup", onKeyUpEscape);
});
const trapFocusHandlers = {};
function trapFocus(focusContainer, focusableElement = focusContainer) {
  var focusableElements = getFocusableElements(focusContainer),
    firstFocusable = focusableElements[0],
    lastFocusableElement = focusableElements[focusableElements["length"] - 1];
  (removeTrapFocus(),
    (trapFocusHandlers["focusin"] = (event20) => {
      if (
        event20["target"] !== focusContainer &&
        event20["target"] !== lastFocusableElement &&
        event20["target"] !== firstFocusable
      )
        return;
      document["addEventListener"]("keydown", trapFocusHandlers["keydown"]);
    }),
    (trapFocusHandlers["focusout"] = function () {
      document["removeEventListener"]("keydown", trapFocusHandlers["keydown"]);
    }),
    (trapFocusHandlers["keydown"] = function (event21) {
      if (event21["code"]["toUpperCase"]() !== "TAB") return;
      (event21["target"] === lastFocusableElement &&
        !event21["shiftKey"] &&
        (event21["preventDefault"](), firstFocusable["focus"]()),
        (event21["target"] === focusContainer || event21["target"] === firstFocusable) &&
          event21["shiftKey"] &&
          (event21["preventDefault"](), lastFocusableElement["focus"]()));
    }),
    document["addEventListener"]("focusout", trapFocusHandlers["focusout"]),
    document["addEventListener"]("focusin", trapFocusHandlers["focusin"]),
    focusableElement["focus"](),
    focusableElement["tagName"] === "INPUT" &&
      ["search", "text", "email", "url"]["includes"](focusableElement["type"]) &&
      focusableElement["value"] &&
      focusableElement["setSelectionRange"](0, focusableElement["value"]["length"]));
}
function pauseAllMedia() {
  (document["querySelectorAll"](".js-youtube")["forEach"]((iframe) => {
    iframe["contentWindow"]["postMessage"](
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*",
    );
  }),
    document["querySelectorAll"](".js-vimeo")["forEach"]((iframeElement) => {
      iframeElement["contentWindow"]["postMessage"]('{"method":"pause"}', "*");
    }),
    document["querySelectorAll"]("media-gallery template video")["forEach"]((media) =>
      media["pause"](),
    ),
    document["querySelectorAll"]("product-model")["forEach"]((mediaElement) => {
      if (mediaElement["modelViewerUI"]) mediaElement["modelViewerUI"]["pause"]();
    }));
}
function removeTrapFocus(focusElement2 = null) {
  (document["removeEventListener"]("focusin", trapFocusHandlers["focusin"]),
    document["removeEventListener"]("focusout", trapFocusHandlers["focusout"]),
    document["removeEventListener"]("keydown", trapFocusHandlers["keydown"]));
  if (focusElement2) focusElement2["focus"]();
}
function onKeyUpEscape(event22) {
  if (event22["code"]["toUpperCase"]() !== "ESCAPE") return;
  const openDetails = event22["target"]["closest"]("details[open]");
  if (!openDetails) return;
  const summaryElement = openDetails["querySelector"]("summary");
  (openDetails["removeAttribute"]("open"),
    summaryElement["setAttribute"]("aria-expanded", ![]),
    summaryElement["focus"]());
}
class QuantityInput extends HTMLElement {
  constructor() {
    (super(),
      (this["input"] = this["querySelector"]("input")),
      (this["changeEvent"] = new Event("change", {
        bubbles: forceClose,
      })),
      (this["quantityGifts"] = document["getElementById"](
        "quantity-gifts-" + this["dataset"]["section"],
      )),
      this["input"]["addEventListener"]("change", this["onInputChange"]["bind"](this)),
      this["querySelectorAll"]("button")["forEach"]((inputElement) =>
        inputElement["addEventListener"]("click", this["onButtonClick"]["bind"](this)),
      ));
  }
  ["quantityUpdateUnsubscriber"] = undefined;
  ["connectedCallback"]() {
    (this["validateQtyRules"](),
      (this["quantityUpdateUnsubscriber"] = subscribe(
        PUB_SUB_EVENTS["quantityUpdate"],
        this["validateQtyRules"]["bind"](this),
      )));
  }
  ["disconnectedCallback"]() {
    this["quantityUpdateUnsubscriber"] && this["quantityUpdateUnsubscriber"]();
  }
  ["onInputChange"](event23) {
    this["validateQtyRules"]();
  }
  ["onButtonClick"](event24) {
    event24["preventDefault"]();
    const inputValue = this["input"]["value"];
    event24["target"]["name"] === "plus" ? this["input"]["stepUp"]() : this["input"]["stepDown"]();
    if (inputValue !== this["input"]["value"]) this["input"]["dispatchEvent"](this["changeEvent"]);
  }
  ["validateQtyRules"]() {
    const quantity3 = parseInt(this["input"]["value"]);
    if (this["input"]["min"]) {
      const minQuantity2 = parseInt(this["input"]["min"]),
        minusButton = this["querySelector"](".quantity__button[name='minus']");
      minusButton["classList"]["toggle"]("disabled", quantity3 <= minQuantity2);
    }
    if (this["input"]["max"]) {
      const maxQuantity = parseInt(this["input"]["max"]),
        plusButton = this["querySelector"](".quantity__button[name='plus']");
      plusButton["classList"]["toggle"]("disabled", quantity3 >= maxQuantity);
    }
    if (this["quantityGifts"] && this["quantityGifts"]["unlockGifts"])
      this["quantityGifts"]["unlockGifts"](quantity3);
  }
}
customElements["define"]("quantity-input", QuantityInput);
function debounce(fn, delay) {
  let timeoutId;
  return (...args) => {
    (clearTimeout(timeoutId), (timeoutId = setTimeout(() => fn["apply"](this, args), delay)));
  };
}
function fetchConfig(responseType = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/" + responseType,
    },
  };
}
function addDays(days, days2) {
  var date2 = new Date(days);
  return (date2["setDate"](date2["getDate"]() + days2), date2);
}
function formatDates(dateValue, dateString, maxDays = 27) {
  if (!dateValue || !dateString) return;
  const parsedDate = new Date(dateString + "T00:00:00Z"),
    year = parsedDate["getFullYear"](),
    month = parsedDate["getMonth"](),
    dayOfMonth = parsedDate["getDate"](),
    date3 = new Date(year, month, dayOfMonth),
    millisecondsDifference = dateValue - date3,
    daysCount = Math["ceil"](millisecondsDifference / (1000 * 3600 * 24));
  return daysCount <= maxDays;
}
typeof window["Shopify"] == "undefined" && (window["Shopify"] = {});
((Shopify["bind"] = function (callback, thisArg) {
  return function () {
    return callback["apply"](thisArg, arguments);
  };
}),
  (Shopify["setSelectorByValue"] = function (selectElement, valueToMatch) {
    for (
      var optionIndex = 0, optionsLength = selectElement["options"]["length"];
      optionIndex < optionsLength;
      optionIndex++
    ) {
      var optionElement = selectElement["options"][optionIndex];
      if (valueToMatch == optionElement["value"] || valueToMatch == optionElement["innerHTML"])
        return ((selectElement["selectedIndex"] = optionIndex), optionIndex);
    }
  }),
  (Shopify["addListener"] = function (target, eventName, listener) {
    target["addEventListener"]
      ? target["addEventListener"](eventName, listener, ![])
      : target["attachEvent"]("on" + eventName, listener);
  }),
  (Shopify["postLink"] = function (actionUrl, options) {
    options = options || {};
    var formMethod = options["method"] || "post",
      parameters = options["parameters"] || {},
      formElement = document["createElement"]("form");
    (formElement["setAttribute"]("method", formMethod),
      formElement["setAttribute"]("action", actionUrl));
    for (var inputName2 in parameters) {
      var inputElement2 = document["createElement"]("input");
      (inputElement2["setAttribute"]("type", "hidden"),
        inputElement2["setAttribute"]("name", inputName2),
        inputElement2["setAttribute"]("value", parameters[inputName2]),
        formElement["appendChild"](inputElement2));
    }
    (document["body"]["appendChild"](formElement),
      formElement["submit"](),
      document["body"]["removeChild"](formElement));
  }),
  (Shopify["CountryProvinceSelector"] = function (elementId, elementId2, elementController) {
    ((this["countryEl"] = document["getElementById"](elementId)),
      (this["provinceEl"] = document["getElementById"](elementId2)),
      (this["provinceContainer"] = document["getElementById"](
        elementController["hideElement"] || elementId2,
      )),
      Shopify["addListener"](
        this["countryEl"],
        "change",
        Shopify["bind"](this["countryHandler"], this),
      ),
      this["initCountry"](),
      this["initProvince"]());
  }),
  (Shopify["CountryProvinceSelector"]["prototype"] = {
    initCountry: function () {
      var defaultCountry = this["countryEl"]["getAttribute"]("data-default");
      (Shopify["setSelectorByValue"](this["countryEl"], defaultCountry), this["countryHandler"]());
    },
    initProvince: function () {
      var defaultProvince = this["provinceEl"]["getAttribute"]("data-default");
      defaultProvince &&
        this["provinceEl"]["options"]["length"] > 0 &&
        Shopify["setSelectorByValue"](this["provinceEl"], defaultProvince);
    },
    countryHandler: function (unusedParam2) {
      var selectedCountryOption = this["countryEl"]["options"][this["countryEl"]["selectedIndex"]],
        provincesJson = selectedCountryOption["getAttribute"]("data-provinces"),
        parsedData = JSON["parse"](provincesJson);
      this["clearOptions"](this["provinceEl"]);
      if (parsedData && parsedData["length"] == 0)
        this["provinceContainer"]["style"]["display"] = "none";
      else {
        for (var index7 = 0; index7 < parsedData["length"]; index7++) {
          var selectedCountryOption = document["createElement"]("option");
          ((selectedCountryOption["value"] = parsedData[index7][0]),
            (selectedCountryOption["innerHTML"] = parsedData[index7][1]),
            this["provinceEl"]["appendChild"](selectedCountryOption));
        }
        this["provinceContainer"]["style"]["display"] = "";
      }
    },
    clearOptions: function (parent) {
      while (parent["firstChild"]) {
        parent["removeChild"](parent["firstChild"]);
      }
    },
    setOptions: function (container, nodes) {
      for (var index8 = 0, arrayLength = nodes["length"]; index8 < nodes["length"]; index8++) {
        var optionElement2 = document["createElement"]("option");
        ((optionElement2["value"] = nodes[index8]),
          (optionElement2["innerHTML"] = nodes[index8]),
          container["appendChild"](optionElement2));
      }
    },
  }));
class InternalVideo extends HTMLElement {
  constructor() {
    (super(),
      (this["playButton"] = this["querySelector"](".internal-video__play")),
      (this["noPlayBtn"] = this["dataset"]["noPlayBtn"] === "true"),
      (this["loaded"] = ![]),
      (this["suspended"] = ![]),
      (this["soundButton"] = this["querySelector"](".internal-video__sound-btn")),
      (this["video"] = this["querySelector"]("video")),
      (this["invalidFormatSrc"] = this["video"]["querySelector"](
        'source[type="application/x-mpegURL"]',
      )));
    if (this["invalidFormatSrc"]) this["invalidFormatSrc"]["remove"]();
    ((this["timeline"] = this["querySelector"](".internal-video__timeline")),
      (this["dragging"] = ![]));
    if (this["playButton"])
      this["playButton"]["addEventListener"]("click", this["playVideo"]["bind"](this));
    if (this["soundButton"])
      this["soundButton"]["addEventListener"]("click", this["toggleSound"]["bind"](this));
    if (this["video"]) this["video"]["addEventListener"]("ended", this["endedVideo"]["bind"](this));
    this["timeline"] &&
      (this["video"]["addEventListener"]("timeupdate", this["updateTimeline"]["bind"](this)),
      this["timeline"]["addEventListener"]("click", this["seekVideo"]["bind"](this)),
      this["timeline"]["addEventListener"]("mousedown", this["startDrag"]["bind"](this)),
      this["timeline"]["addEventListener"]("touchstart", this["startDrag"]["bind"](this)),
      document["addEventListener"]("mouseup", this["stopDrag"]["bind"](this)),
      document["addEventListener"]("touchend", this["stopDrag"]["bind"](this)),
      document["addEventListener"]("mousemove", this["drag"]["bind"](this)),
      document["addEventListener"]("touchmove", this["drag"]["bind"](this)));
    (this["video"]["addEventListener"]("waiting", this["showSpinner"]["bind"](this)),
      this["video"]["addEventListener"]("canplaythrough", this["hideSpinner"]["bind"](this)),
      this["video"]["addEventListener"]("play", this["hideSpinner"]["bind"](this)));
    if (this["dataset"]["autoplay"] === "true" && "IntersectionObserver" in window) {
      const intersectionObserverOptions = {
        root: null,
        rootMargin: "0px",
        threshold: 0.05,
      };
      ((this["observer"] = new IntersectionObserver(
        this["handleIntersection"]["bind"](this),
        intersectionObserverOptions,
      )),
        this["observer"]["observe"](this));
    }
  }
  ["playVideo"]() {
    if (this["video"]["paused"]) {
      !this["loaded"] && (this["video"]["load"](), (this["loaded"] = forceClose));
      this["classList"]["add"]("internal-video--playing");
      if (this["playButton"] && this["noPlayBtn"])
        this["playButton"]["style"]["visibility"] = "hidden";
      const playPromise = this["video"]["play"]();
      playPromise !== undefined &&
        playPromise["then"](() => {
          this["classList"]["add"]("internal-video--playing");
          if (this["playButton"] && this["noPlayBtn"])
            this["playButton"]["style"]["visibility"] = "hidden";
        })["catch"]((options2) => {
          this["classList"]["remove"]("internal-video--playing");
          if (this["playButton"] && this["noPlayBtn"])
            this["playButton"]["style"]["visibility"] = "visible";
        });
    } else (this["video"]["pause"](), this["classList"]["remove"]("internal-video--playing"));
  }
  ["endedVideo"]() {
    this["classList"]["remove"]("internal-video--playing");
  }
  ["toggleSound"]() {
    this["video"]["muted"]
      ? ((this["video"]["muted"] = ![]), this["classList"]["remove"]("internal-video--muted"))
      : ((this["video"]["muted"] = forceClose), this["classList"]["add"]("internal-video--muted"));
  }
  ["updateTimeline"]() {
    const playbackPercent = (this["video"]["currentTime"] / this["video"]["duration"]) * 100;
    this["style"]["setProperty"]("--completed", playbackPercent + "%");
  }
  ["hideSpinner"]() {
    this["classList"]["remove"]("internal-video--loading");
  }
  ["startDrag"](event25) {
    (event25["preventDefault"](), (this["dragging"] = forceClose), this["drag"](event25));
  }
  ["stopDrag"]() {
    this["dragging"] = ![];
  }
  ["drag"](touchEvent) {
    if (!this["dragging"]) return;
    (touchEvent["touches"] && (touchEvent = touchEvent["touches"][0]),
      this["seekVideo"](touchEvent));
  }
  ["seekVideo"](event26) {
    const timelineRect = this["timeline"]["getBoundingClientRect"](),
      offsetX = event26["clientX"] - timelineRect["left"],
      heightToWidthRatio = offsetX / timelineRect["width"];
    this["video"]["currentTime"] = heightToWidthRatio * this["video"]["duration"];
  }
  ["showSpinner"]() {
    this["classList"]["add"]("internal-video--loading");
  }
  ["hideSpinner"]() {
    this["classList"]["remove"]("internal-video--loading");
  }
  ["handleIntersection"](elements) {
    elements["forEach"]((entry) => {
      if (entry["isIntersecting"]) {
        for (let videoElement of this["video"]["querySelectorAll"]("source[data-src]")) {
          (videoElement["setAttribute"]("src", videoElement["getAttribute"]("data-src")),
            videoElement["removeAttribute"]("data-src"));
        }
        this["video"]["load"]();
        var playPromise2 = this["video"]["play"]();
        (playPromise2 !== undefined &&
          playPromise2["catch"]((event27) => {
            if (event27["name"] === "NotAllowedError") {
              this["classList"]["remove"]("internal-video--playing");
              if (this["playButton"] && this["noPlayBtn"])
                this["playButton"]["style"]["visibility"] = "visible";
            }
          })["then"](() => {
            this["video"]["play"]();
          }),
          this["observer"]["disconnect"]());
      }
    });
  }
}
customElements["define"]("internal-video", InternalVideo);
class ComparisonSlider extends HTMLElement {
  constructor() {
    (super(),
      (this["sliderOverlay"] = this["querySelector"](".comparison-slider__overlay")),
      (this["sliderLine"] = this["querySelector"](".comparison-slider__line")),
      (this["sliderInput"] = this["querySelector"](".comparison-slider__input")),
      this["sliderInput"]["addEventListener"]("input", this["handleChange"]["bind"](this)));
  }
  ["handleChange"](event28) {
    const sliderValue = event28["currentTarget"]["value"];
    ((this["sliderOverlay"]["style"]["width"] = sliderValue + "%"),
      (this["sliderLine"]["style"]["left"] = sliderValue + "%"));
  }
}
customElements["define"]("comparison-slider", ComparisonSlider);
class PromoPopup extends HTMLElement {
  constructor() {
    (super(),
      (this["testMode"] = this["dataset"]["testMode"] === "true"),
      (this["secondsDelay"] = this["dataset"]["delaySeconds"]),
      (this["daysFrequency"] = this["dataset"]["delayDays"]),
      (this["modal"] = this["querySelector"](".sign-up-popup-modal")),
      (this["timer"] = this["querySelector"](".popup-modal__timer")),
      (this["timerDuration"] = this["dataset"]["timerDuration"]),
      (this["closeBtns"] = this["querySelectorAll"](".promp-popup__close-btn")),
      (this["overlay"] = document["querySelector"](".sign-up-popup-overlay")),
      (this["storageKey"] = "promo-bar-data-" + window["location"]["host"]));
    if (!this["testMode"]) {
      if (localStorage["getItem"](this["storageKey"]) === null) this["openPopupModal"]();
      else {
        const storedData = JSON["parse"](localStorage["getItem"](this["storageKey"])),
          nextDisplayDate = new Date(storedData["next_display_date"]);
        currentDate["getTime"]() > nextDisplayDate["getTime"]() && this["openPopupModal"]();
      }
    } else {
      if (this["timer"]) this["displayPromoTimer"]();
    }
    this["closeBtns"]["forEach"]((popupElement) => {
      popupElement["addEventListener"]("click", this["closeModal"]["bind"](this));
    });
  }
  ["openPopupModal"]() {
    setTimeout(
      () => {
        (this["modal"]["classList"]["add"]("popup-modal--active"),
          this["overlay"]["classList"]["add"]("popup-overlay--active"));
        const nextDisplayDate2 = addDays(currentDate, parseInt(this["daysFrequency"])),
          promoPopupState = {
            next_display_date: nextDisplayDate2,
            dismissed: ![],
          };
        localStorage["setItem"](this["storageKey"], JSON["stringify"](promoPopupState));
        if (this["timer"]) this["displayPromoTimer"]();
      },
      parseInt(this["secondsDelay"]) * 1000 + 3000,
    );
  }
  ["displayPromoTimer"]() {
    ((this["minutesSpan"] = this["querySelector"](".popup-modal__timer__minutes")),
      (this["secondsSpan"] = this["querySelector"](".popup-modal__timer__seconds")),
      (this["totalSeconds"] = parseFloat(this["timerDuration"]) * 60),
      this["updateTimer"]());
    const timerInterval = setInterval(() => {
      ((this["totalSeconds"] -= 1),
        this["updateTimer"](),
        this["totalSeconds"] <= 0 &&
          (this["totalSeconds"] = parseFloat(this["timerDuration"]) * 60 - 45));
    }, 1000);
  }
  ["updateTimer"]() {
    let minutes = Math["floor"](this["totalSeconds"] / 60);
    if (minutes["toString"]()["length"] === 1) minutes = "0" + minutes;
    let secondsRemaining = this["totalSeconds"] % 60;
    if (secondsRemaining["toString"]()["length"] === 1) secondsRemaining = "0" + secondsRemaining;
    ((this["minutesSpan"]["innerText"] = minutes),
      (this["secondsSpan"]["innerText"] = secondsRemaining));
  }
  ["closeModal"]() {
    (this["modal"]["classList"]["remove"]("popup-modal--active"),
      this["overlay"]["classList"]["remove"]("popup-overlay--active"));
  }
}
customElements["define"]("promo-popup", PromoPopup);
class SectionsGroup extends HTMLElement {
  constructor() {
    (super(),
      (this["sectionOneContainer"] = this["querySelector"](
        ".section-group__section-one-container",
      )),
      (this["sectionTwoContainer"] = this["querySelector"](
        ".section-group__section-two-container",
      )),
      this["transferSections"](),
      document["addEventListener"]("shopify:section:load", this["transferSections"]["bind"](this)));
  }
  ["transferSections"]() {
    ((this["sectionOne"] = document["querySelector"](
      this["dataset"]["sectionOneId"] + " .content-for-grouping",
    )),
      (this["sectionTwo"] = document["querySelector"](
        this["dataset"]["sectionTwoId"] + " .content-for-grouping",
      )));
    if (this["sectionOne"] && !this["sectionOneContainer"]["childNodes"]["length"])
      this["sectionOneContainer"]["appendChild"](this["sectionOne"]);
    if (this["sectionTwo"] && !this["sectionTwoContainer"]["childNodes"]["length"])
      this["sectionTwoContainer"]["appendChild"](this["sectionTwo"]);
  }
}
customElements["define"]("section-group", SectionsGroup);
class ClickableDiscount extends HTMLElement {
  constructor() {
    (super(),
      (this["button"] = this["querySelector"](".clickable-discount__btn")),
      this["button"]["addEventListener"]("click", this["handleClick"]["bind"](this)),
      this["dataset"]["applied"] === "true"
        ? this["handleClick"]()
        : this["reapplyDiscountIfApplicable"]());
  }
  ["handleClick"]() {
    ((this["dataset"]["loading"] = "true"),
      (this["button"]["disabled"] = forceClose),
      (this["dataset"]["error"] = "false"),
      fetch("/discount/" + this["dataset"]["code"])
        ["then"]((result) => {
          if (!result["ok"]) throw new Error("Error");
          ((this["dataset"]["applied"] = "true"),
            sessionStorage["setItem"]("discount-" + this["dataset"]["code"] + "-applied", "true"));
        })
        ["catch"]((unusedParam3) => {
          ((this["dataset"]["error"] = "true"), (this["button"]["disabled"] = ![]));
        })
        ["finally"](() => {
          this["dataset"]["loading"] = "false";
        }));
  }
  ["reapplyDiscountIfApplicable"]() {
    const discountCode2 = this["dataset"]["code"];
    sessionStorage["getItem"]("discount-" + discountCode2 + "-applied") &&
      ((this["dataset"]["applied"] = "true"),
      (this["button"]["disabled"] = forceClose),
      setTimeout(() => {
        fetch("/discount/" + discountCode2)["catch"]((event29) => {
          ((this["dataset"]["applied"] = "false"), (this["button"]["disabled"] = ![]));
        });
      }, 3000));
  }
}
customElements["define"]("clickable-discount", ClickableDiscount);
class DynamicDates extends HTMLElement {
  constructor() {
    (super(),
      (this["dateFormat"] = this["dataset"]["dateFormat"]),
      (this["days"] = this["rearrangeDays"](this["dataset"]["dayLabels"]["split"](","))),
      (this["months"] = this["dataset"]["monthLabels"]["split"](",")),
      (this["elementsToChange"] = this["querySelectorAll"]('[data-dynamic-date="true"]')),
      this["insertDates"](),
      document["addEventListener"]("shopify:section:load", (options3) => {
        this["insertDates"]();
      }));
  }
  ["insertDates"]() {
    this["elementsToChange"]["forEach"]((dateElement) => {
      const datasetText = dateElement["dataset"]["text"],
        minDays = parseInt(dateElement["dataset"]["minDays"]),
        maxDays2 = parseInt(dateElement["dataset"]["maxDays"]),
        calculatedDate = addDays(currentDate, minDays);
      let daySuffix = "th";
      const dayOfMonth2 = calculatedDate["getDate"]();
      if (dayOfMonth2 === 1 || dayOfMonth2 === 21 || dayOfMonth2 === 31) daySuffix = "st";
      else {
        if (dayOfMonth2 === 2 || dayOfMonth2 === 22) daySuffix = "nd";
        else {
          if (dayOfMonth2 === 3 || dayOfMonth2 === 23) daySuffix = "rd";
        }
      }
      const targetDate = addDays(currentDate, maxDays2);
      let ordinalSuffix = "th";
      const dayOfMonth3 = targetDate["getDate"]();
      if (dayOfMonth3 === 1 || dayOfMonth3 === 21 || dayOfMonth3 === 31) ordinalSuffix = "st";
      else {
        if (dayOfMonth3 === 2 || dayOfMonth3 === 22) ordinalSuffix = "nd";
        else {
          if (dayOfMonth3 === 3 || dayOfMonth3 === 23) ordinalSuffix = "rd";
        }
      }
      let startDate, endDate;
      if (this["dateFormat"] === "day_dd_mm")
        ((startDate =
          this["days"][calculatedDate["getDay"]()] +
          ", " +
          calculatedDate["getDate"]() +
          ". " +
          this["months"][calculatedDate["getMonth"]()]),
          (endDate =
            this["days"][targetDate["getDay"]()] +
            ", " +
            targetDate["getDate"]() +
            ". " +
            this["months"][targetDate["getMonth"]()]));
      else {
        if (this["dateFormat"] === "mm_dd")
          ((startDate =
            this["months"][calculatedDate["getMonth"]()] +
            " " +
            calculatedDate["getDate"]() +
            daySuffix),
            (endDate =
              this["months"][targetDate["getMonth"]()] +
              " " +
              targetDate["getDate"]() +
              ordinalSuffix));
        else {
          if (this["dateFormat"] === "dd_mm")
            ((startDate =
              calculatedDate["getDate"]() + ". " + this["months"][calculatedDate["getMonth"]()]),
              (endDate =
                targetDate["getDate"]() + ". " + this["months"][targetDate["getMonth"]()]));
          else {
            if (this["dateFormat"] === "dd_mm_no_dot")
              ((startDate =
                calculatedDate["getDate"]() + " " + this["months"][calculatedDate["getMonth"]()]),
                (endDate =
                  targetDate["getDate"]() + " " + this["months"][targetDate["getMonth"]()]));
            else {
              if (this["dateFormat"] === "day_dd_mm_numeric") {
                const dayOfMonthPadded =
                    String(calculatedDate["getDate"]())["length"] > 1
                      ? calculatedDate["getDate"]()
                      : "0" + calculatedDate["getDate"](),
                  monthPadded =
                    String(calculatedDate["getMonth"]() + 1)["length"] > 1
                      ? calculatedDate["getMonth"]() + 1
                      : "0" + (calculatedDate["getMonth"]() + 1);
                startDate =
                  this["days"][calculatedDate["getDay"]()] +
                  ", " +
                  dayOfMonthPadded +
                  ". " +
                  monthPadded +
                  ".";
                const dayOfMonthString =
                    String(targetDate["getDate"]())["length"] > 1
                      ? targetDate["getDate"]()
                      : "0" + targetDate["getDate"](),
                  paddedMonth =
                    String(targetDate["getMonth"]() + 1)["length"] > 1
                      ? targetDate["getMonth"]() + 1
                      : "0" + (targetDate["getMonth"]() + 1);
                endDate =
                  this["days"][targetDate["getDay"]()] +
                  ", " +
                  dayOfMonthString +
                  ". " +
                  paddedMonth +
                  ".";
              } else {
                if (this["dateFormat"] === "dd_mm_numeric") {
                  const dayOfMonthPadded2 =
                      String(calculatedDate["getDate"]())["length"] > 1
                        ? calculatedDate["getDate"]()
                        : "0" + calculatedDate["getDate"](),
                    monthPadded2 =
                      String(calculatedDate["getMonth"]() + 1)["length"] > 1
                        ? calculatedDate["getMonth"]() + 1
                        : "0" + (calculatedDate["getMonth"]() + 1);
                  startDate = dayOfMonthPadded2 + ". " + monthPadded2 + ".";
                  const dayOfMonthPadded3 =
                      String(targetDate["getDate"]())["length"] > 1
                        ? targetDate["getDate"]()
                        : "0" + targetDate["getDate"](),
                    monthString =
                      String(targetDate["getMonth"]() + 1)["length"] > 1
                        ? targetDate["getMonth"]() + 1
                        : "0" + (targetDate["getMonth"]() + 1);
                  endDate = dayOfMonthPadded3 + ". " + monthString + ".";
                } else
                  ((startDate =
                    this["days"][calculatedDate["getDay"]()] +
                    ", " +
                    this["months"][calculatedDate["getMonth"]()] +
                    " " +
                    calculatedDate["getDate"]() +
                    daySuffix),
                    (endDate =
                      this["days"][targetDate["getDay"]()] +
                      ", " +
                      this["months"][targetDate["getMonth"]()] +
                      " " +
                      targetDate["getDate"]() +
                      ordinalSuffix));
              }
            }
          }
        }
      }
      const formattedText = datasetText["replace"]("[start_date]", startDate),
        textWithEndDate = formattedText["replace"]("[end_date]", endDate);
      dateElement["innerHTML"] = textWithEndDate;
    });
  }
  ["rearrangeDays"](dates) {
    return (dates["unshift"](dates[6]), (dates["length"] = 7), dates);
  }
}
customElements["define"]("dynamic-dates", DynamicDates);
class StickyAtc extends HTMLElement {
  constructor() {
    (super(),
      (this["isAfterScroll"] = this["dataset"]["afterScroll"] === "true"),
      (this["isScrollBtn"] = this["dataset"]["scrollBtn"] === "true"),
      (this["mainAtcBtn"] = document["querySelector"](
        "#ProductSubmitButton-" + this["dataset"]["section"],
      )),
      (this["floatingBtns"] = document["querySelectorAll"](".floating-btn")),
      this["footerSpacing"]());
    this["isAfterScroll"]
      ? this["mainAtcBtn"] &&
        (this["checkATCScroll"](),
        document["addEventListener"]("scroll", this["checkATCScroll"]["bind"](this)))
      : this["floatingBtns"]["forEach"]((stickyElement) => {
          stickyElement["style"]["setProperty"]("--sticky-atc-offset", this["offsetHeight"] + "px");
        });
    if (this["isScrollBtn"]) {
      ((this["scrollBtn"] = this["querySelector"](".sticky-atc__scroll-btn")),
        (this["scrollDestination"] = document["querySelector"](
          "" + this["dataset"]["scrollDestination"]["replace"]("id", this["dataset"]["section"]),
        )));
      if (this["scrollBtn"] && this["scrollDestination"])
        this["scrollBtn"]["addEventListener"]("click", this["handleScrollBtn"]["bind"](this));
    }
  }
  ["checkATCScroll"]() {
    (window["scrollY"] > this["mainAtcBtn"]["offsetTop"] + this["mainAtcBtn"]["offsetHeight"]
      ? ((this["style"]["transform"] = "none"), (this["scrolledPast"] = forceClose))
      : ((this["style"]["transform"] = ""), (this["scrolledPast"] = ![])),
      this["floatingBtns"]["forEach"]((element10) => {
        this["scrolledPast"]
          ? element10["style"]["setProperty"]("--sticky-atc-offset", this["offsetHeight"] + "px")
          : element10["style"]["setProperty"]("--sticky-atc-offset", "0px");
      }));
  }
  ["handleScrollBtn"]() {
    const stickyHeader = document["querySelector"]("sticky-header"),
      scrollOffset = stickyHeader ? stickyHeader["clientHeight"] : 0;
    window["scrollTo"]({
      top: this["scrollDestination"]["offsetTop"] - scrollOffset - 15,
      behavior: "smooth",
    });
  }
  ["footerSpacing"]() {
    let stickyAtcFooterSpacer = document["querySelector"](".sticky-atc-footer-spacer");
    if (stickyAtcFooterSpacer) return;
    ((stickyAtcFooterSpacer = document["createElement"]("div")),
      (stickyAtcFooterSpacer["className"] = "sticky-atc-footer-spacer"),
      (stickyAtcFooterSpacer["style"]["height"] = this["clientHeight"] - 1 + "px"),
      (stickyAtcFooterSpacer["style"]["display"] = "block"));
    const footerElement = document["querySelector"](".footer");
    if (footerElement)
      stickyAtcFooterSpacer["style"]["background"] =
        window["getComputedStyle"](footerElement)["background"];
    document["body"]["appendChild"](stickyAtcFooterSpacer);
  }
}
customElements["define"]("sticky-atc", StickyAtc);
class BundleDeals extends HTMLElement {
  constructor() {
    (super(),
      (this["productContainers"] = this["querySelectorAll"](".bundle-deals__product-js")),
      (this["mediaItemContainers"] = this["querySelectorAll"](
        ".bundle-deals__media-item-container-js",
      )),
      (this["mediaItemImgs"] = this["querySelectorAll"](".bundle-deals__media-item-img-js")),
      (this["checkboxes"] = this["querySelectorAll"](".bundle-deals__checkbox-js")),
      (this["variantPickers"] = this["querySelectorAll"](".bundle-deals__variant-selects-js")),
      (this["skipNonExistent"] = this["dataset"]["skipNonExistent"] === "true"),
      (this["skipUnavailable"] = this["dataset"]["skipUnavailable"] === "true"),
      (this["prices"] = this["querySelectorAll"](".bundle-deals__price-js")),
      (this["comparePrices"] = this["querySelectorAll"](".bundle-deals__compare-price-js")),
      (this["totalPrice"] = this["querySelector"](".bundle-deals__total-price-js")),
      (this["totalComparePrice"] = this["querySelector"](".bundle-deals__total-compare-price-js")),
      (this["updatePrices"] = this["dataset"]["updatePrices"] === "true"),
      (this["percentageLeft"] = parseFloat(this["dataset"]["percentageLeft"])),
      (this["fixedDiscount"] = parseFloat(this["dataset"]["fixedDiscount"])),
      (this["currencySymbol"] = this["dataset"]["currencySymbol"]),
      (this["selectedVariants"] = {
        id_1: null,
        id_2: null,
        id_3: null,
        id_4: null,
        id_5: null,
      }),
      (this["formVariants"] = []),
      this["initIds"](),
      this["checkboxes"]["forEach"]((element11) => {
        element11["addEventListener"]("change", this["handleCheckboxChange"]["bind"](this));
      }),
      this["variantPickers"]["forEach"]((container2) => {
        container2["addEventListener"]("change", this["handleSelectChange"]["bind"](this));
      }));
  }
  ["initIds"]() {
    (this["checkboxes"]["forEach"]((bundleElement) => {
      this["selectedVariants"][bundleElement["dataset"]["idIndex"]] = {
        id: bundleElement["dataset"]["id"],
        price: bundleElement["dataset"]["price"],
        comparePrice: bundleElement["dataset"]["comparePrice"],
        checked: forceClose,
      };
    }),
      this["updateFormIds"]());
  }
  ["handleCheckboxChange"](event30) {
    const selectedOptionInput = event30["currentTarget"],
      isChecked = selectedOptionInput["checked"],
      containerIndex = parseInt(selectedOptionInput["dataset"]["index"]);
    this["selectedVariants"][selectedOptionInput["dataset"]["idIndex"]]["checked"] = isChecked;
    const productContainer = this["productContainers"][containerIndex],
      bundleSelects = productContainer["querySelectorAll"]("select");
    isChecked
      ? (this["mediaItemContainers"][containerIndex]["classList"]["remove"](
          "bundle-deals__media-item--disabled",
        ),
        productContainer["classList"]["remove"]("bundle-deals__product--deselected"),
        bundleSelects["forEach"]((element12) => {
          element12["removeAttribute"]("disabled");
        }))
      : (this["mediaItemContainers"][containerIndex]["classList"]["add"](
          "bundle-deals__media-item--disabled",
        ),
        productContainer["classList"]["add"]("bundle-deals__product--deselected"),
        bundleSelects["forEach"]((dealElement) => {
          dealElement["setAttribute"]("disabled", "");
        }));
    this["updateFormIds"]();
    if (this["updatePrices"]) this["updateTotalPrice"]();
  }
  ["handleSelectChange"](event31) {
    const currentTarget = event31["currentTarget"],
      index9 = parseInt(currentTarget["dataset"]["index"]),
      selectedOptions = Array["from"](
        currentTarget["querySelectorAll"]("select"),
        (selectEl) => selectEl["value"],
      ),
      filteredVariants = JSON["parse"](
        currentTarget["querySelector"]('[type="application/json"]')["textContent"],
      )["filter"](
        (variant2) => currentTarget["querySelector"](":checked")["value"] === variant2["option1"],
      ),
      smallSelects = [...currentTarget["querySelectorAll"](".select--small")];
    updateVariantStatuses(filteredVariants, smallSelects);
    const bundle = JSON["parse"](
      currentTarget["querySelector"]('[type="application/json"]')["textContent"],
    )["find"]((bundleItem) => {
      return !bundleItem["options"]
        ["map"]((option, index10) => {
          return selectedOptions[index10] === option;
        })
        ["includes"](![]);
    });
    if (!bundle) {
      if (this["skipNonExistent"])
        findAvailableVariant(
          currentTarget,
          selectedOptions,
          ![],
          forceClose,
          this["skipUnavailable"],
        );
      return;
    }
    if (this["skipUnavailable"] && !bundle["available"]) {
      if (findAvailableVariant(currentTarget, selectedOptions, ![], forceClose, forceClose)) return;
    }
    let {
      price: unitPrice,
      compare_at_price: compareAtPrice,
      featured_image: featuredImage,
    } = bundle;
    unitPrice = parseInt(unitPrice);
    let parsedValue = compareAtPrice ? parseInt(compareAtPrice) : unitPrice;
    const percentageLeft = currentTarget["dataset"]["percentageLeft"] ?? 1,
      fixedDiscount = currentTarget["dataset"]["fixedDiscount"] ?? 0;
    unitPrice = unitPrice * percentageLeft - fixedDiscount;
    if (featuredImage) featuredImage = featuredImage["src"];
    const dealId = bundle["id"];
    ((this["selectedVariants"][currentTarget["dataset"]["idIndex"]]["id"] = dealId),
      (this["selectedVariants"][currentTarget["dataset"]["idIndex"]]["price"] = unitPrice),
      (this["selectedVariants"][currentTarget["dataset"]["idIndex"]]["comparePrice"] = parsedValue),
      this["updateFormIds"](),
      this["updatePrices"] &&
        ((this["prices"][index9]["innerHTML"] =
          this["currencySymbol"] + (unitPrice / 100)["toFixed"](2)),
        parsedValue > unitPrice
          ? (this["comparePrices"][index9]["innerHTML"] =
              this["currencySymbol"] + (parsedValue / 100)["toFixed"](2))
          : (this["comparePrices"][index9]["innerHTML"] = ""),
        this["updateTotalPrice"]()),
      featuredImage &&
        featuredImage["length"] > 0 &&
        this["mediaItemImgs"][index9] &&
        (this["mediaItemImgs"][index9]["src"] = featuredImage));
  }
  ["updateFormIds"]() {
    const bundleItems = [],
      selectedVariants = this["selectedVariants"];
    for (const index11 in selectedVariants) {
      const checkboxInput = selectedVariants[index11];
      if (checkboxInput != null && checkboxInput["checked"]) {
        const foundIndex = bundleItems["findIndex"](
          (bundleItem2) => bundleItem2["id"] === checkboxInput["id"],
        );
        foundIndex < 0
          ? bundleItems["unshift"]({
              id: checkboxInput["id"],
              quantity: 1,
            })
          : (bundleItems[foundIndex]["quantity"] += 1);
      }
    }
    this["formVariants"] = bundleItems;
  }
  ["updateTotalPrice"]() {
    const dealItems = [],
      bundleItems2 = [],
      selectedVariants2 = this["selectedVariants"];
    for (const index12 in selectedVariants2) {
      const option2 = selectedVariants2[index12];
      option2 != null &&
        option2["checked"] &&
        (dealItems["push"](parseInt(option2["price"])),
        bundleItems2["push"](parseInt(option2["comparePrice"])));
    }
    const totalQuantity = dealItems["reduce"]((accumulator, amount) => accumulator + amount, 0),
      discountAmount = totalQuantity * this["percentageLeft"] - this["fixedDiscount"],
      bundleTotalCents = bundleItems2["reduce"]((sum, value2) => sum + value2, 0);
    ((this["totalPrice"]["innerHTML"] =
      this["currencySymbol"] + (discountAmount / 100)["toFixed"](2)),
      bundleTotalCents > discountAmount
        ? (this["totalComparePrice"]["innerHTML"] =
            this["currencySymbol"] + (bundleTotalCents / 100)["toFixed"](2))
        : (this["totalComparePrice"]["innerHTML"] = ""));
  }
}
customElements["define"]("bundle-deals", BundleDeals);
class QuantityBreaks extends HTMLElement {
  constructor() {
    (super(),
      (this["quantityGifts"] = document["getElementById"](
        "quantity-gifts-" + this["dataset"]["section"],
      )),
      (this["inputs"] = this["querySelectorAll"]('input[name="quantity"]')),
      (this["labels"] = this["querySelectorAll"](".quantity-break")),
      (this["jsonData"] = this["querySelector"]('[type="application/json"]')),
      (this["hasVariants"] = this["jsonData"]["dataset"]["hasVariants"] === "true"),
      (this["selectedVariants"] = {
        input_1: [],
        input_2: [],
        input_3: [],
        input_4: [],
        input_5: [],
        input_6: [],
      }),
      (this["updateUnavailable"] = this["dataset"]["updateUnavailable"] === "true"),
      (this["skipNonExistent"] = this["dataset"]["skipNonExistent"] === "true"),
      (this["skipUnavailable"] = this["dataset"]["skipUnavailable"] === "true"),
      (this["formVariants"] = []),
      (this["selectedQuantity"] = 1));
    if (this["querySelector"]("input[checked]"))
      this["selectedQuantity"] = parseInt(this["querySelector"]("input[checked]")["value"]);
    ((this["variantSelects"] = this["querySelectorAll"](".quantity-break__selector-item")),
      (this["updatePrices"] = this["dataset"]["updatePrices"] === "true"),
      (this["moneyFormat"] = this["dataset"]["moneyFormat"]));
    if (this["hasVariants"]) this["initVariants"]();
    (this["inputs"]["forEach"]((element13) => {
      element13["addEventListener"]("change", this["handleChange"]["bind"](this));
    }),
      this["variantSelects"]["forEach"]((element14) => {
        element14["addEventListener"]("change", this["handleSelectChange"]["bind"](this));
      }));
  }
  ["handleSelectChange"](event32) {
    const currentTarget2 = event32["currentTarget"],
      selectedValues2 = Array["from"](
        currentTarget2["querySelectorAll"]("select"),
        (selectElement2) => selectElement2["value"],
      );
    if (this["updateUnavailable"]) {
      const matchingVariants = this["getVariantData"]()["filter"](
          (variant3) =>
            currentTarget2["querySelector"](":checked")["value"] === variant3["option1"],
        ),
        smallSelects2 = [...currentTarget2["querySelectorAll"](".select--small")];
      updateVariantStatuses(matchingVariants, smallSelects2);
    }
    const matchedVariant = this["getVariantData"]()["find"]((variant4) => {
      return !variant4["options"]
        ["map"]((option3, index13) => {
          return selectedValues2[index13] === option3;
        })
        ["includes"](![]);
    });
    if (!matchedVariant) {
      if (this["skipNonExistent"])
        findAvailableVariant(
          currentTarget2,
          selectedValues2,
          ![],
          forceClose,
          this["skipUnavailable"],
        );
      return;
    }
    if (this["skipUnavailable"] && !matchedVariant["available"]) {
      if (findAvailableVariant(currentTarget2, selectedValues2, ![], forceClose, forceClose))
        return;
    }
    currentTarget2["dataset"]["selectedId"] = matchedVariant["id"];
    const selectIndex = currentTarget2["dataset"]["selectIndex"],
      quantityBreakElement = currentTarget2["closest"](".quantity-break"),
      inputName3 = quantityBreakElement["dataset"]["input"];
    ((this["selectedVariants"][inputName3][selectIndex] = matchedVariant["id"]),
      (this["formVariants"] = this["selectedVariants"][inputName3]),
      this["updateMedia"](matchedVariant));
    if (!this["updatePrices"]) return;
    var quantity4 = 0,
      amount2 = 0;
    const breakQuantity = parseFloat(quantityBreakElement["dataset"]["quantity"]),
      percentageLeft2 = parseFloat(quantityBreakElement["dataset"]["percentageLeft"]),
      fixedDiscount2 = parseFloat(quantityBreakElement["dataset"]["fixedDiscount"]);
    for (let index14 = 0; index14 < breakQuantity; index14++) {
      const selectedVariantId = parseInt(this["selectedVariants"][inputName3][index14]),
        variant5 = this["getVariantData"]()["find"](
          (variantCandidate) => parseInt(variantCandidate["id"]) === selectedVariantId,
        );
      if (!variant5) return;
      ((quantity4 += variant5["price"]),
        variant5["compare_at_price"] && variant5["compare_at_price"] > variant5["price"]
          ? (amount2 += variant5["compare_at_price"])
          : (amount2 += variant5["price"]));
    }
    quantity4 = quantity4 * percentageLeft2 - fixedDiscount2;
    const priceDifference = amount2 - quantity4,
      roundedPrice = Math["round"](priceDifference / 100) * 100,
      unitPrice2 = quantity4 / breakQuantity,
      unitPrice3 = amount2 / breakQuantity,
      formattedPrice = formatMoney(quantity4, this["moneyFormat"], forceClose),
      comparePrice2 = formatMoney(amount2, this["moneyFormat"], forceClose),
      formattedAmountSaved = formatMoney(priceDifference, this["moneyFormat"], forceClose),
      formattedAmountSaved2 = formatMoney(roundedPrice, this["moneyFormat"], forceClose),
      formattedPriceEach = formatMoney(unitPrice2, this["moneyFormat"], forceClose),
      formattedComparePriceEach = formatMoney(unitPrice3, this["moneyFormat"], forceClose);
    quantityBreakElement["querySelectorAll"](".variant-price-update")["forEach"]((breakElement) => {
      let datasetText2 = breakElement["dataset"]["text"];
      ((datasetText2 = datasetText2["replace"]("[quantity]", breakQuantity)),
        (datasetText2 = datasetText2["replace"]("[price]", formattedPrice)),
        (datasetText2 = datasetText2["replace"]("[compare_price]", comparePrice2)),
        (datasetText2 = datasetText2["replace"]("[amount_saved]", formattedAmountSaved)),
        (datasetText2 = datasetText2["replace"]("[amount_saved_rounded]", formattedAmountSaved2)),
        (datasetText2 = datasetText2["replace"]("[price_each]", formattedPriceEach)),
        (datasetText2 = datasetText2["replace"]("[compare_price_each]", formattedComparePriceEach)),
        (breakElement["innerHTML"] = datasetText2));
    });
    const comparePriceElement = quantityBreakElement["querySelector"](
      ".quantity-break__compare-price",
    );
    comparePriceElement &&
      (amount2 > quantity4
        ? comparePriceElement["classList"]["remove"]("hidden")
        : comparePriceElement["classList"]["add"]("hidden"));
  }
  ["getVariantData"]() {
    return (
      (this["variantData"] = this["variantData"] || JSON["parse"](this["jsonData"]["textContent"])),
      this["variantData"]
    );
  }
  ["initVariants"]() {
    if (!this["hasVariants"]) return;
    (this["labels"]["forEach"]((quantityBreaksElement) => {
      if (quantityBreaksElement["querySelector"](".quantity-break__variants")) {
        let quantityBreaks = [];
        (quantityBreaksElement["querySelectorAll"](".quantity-break__selector-item")["forEach"](
          (element15) => {
            quantityBreaks["push"](element15["dataset"]["selectedId"]);
          },
        ),
          (this["selectedVariants"][quantityBreaksElement["dataset"]["input"]] = quantityBreaks));
      }
    }),
      (this["formVariants"] = []));
  }
  ["updateMedia"](product) {
    if (!product) return;
    if (!product["featured_media"]) return;
    const mediaGalleryNodes = document["querySelectorAll"](
      '[id^="MediaGallery-' + this["dataset"]["section"] + '"]',
    );
    mediaGalleryNodes["forEach"]((mediaObject) =>
      mediaObject["setActiveMedia"](
        this["dataset"]["section"] + "-" + product["featured_media"]["id"],
        forceClose,
      ),
    );
  }
  ["handleChange"](event33) {
    const quantity5 = parseInt(event33["target"]["value"]);
    this["selectedQuantity"] = quantity5;
    if (this["hasVariants"])
      this["formVariants"] = this["selectedVariants"][event33["target"]["dataset"]["input"]];
    if (this["quantityGifts"]) this["quantityGifts"]["unlockGifts"](quantity5);
  }
}
customElements["define"]("quantity-breaks", QuantityBreaks);
function updateVariantStatuses(variants, variants2) {
  variants2["forEach"]((rootElement3, optionIndex2) => {
    if (optionIndex2 === 0) return;
    const options4 = [...rootElement3["querySelectorAll"]("option")],
      selectedOptionValue = variants2[optionIndex2 - 1]["querySelector"](":checked")["value"],
      availableNextOptions = variants["filter"](
        (variant6) =>
          variant6["available"] && variant6["option" + optionIndex2] === selectedOptionValue,
      )["map"]((variant7) => variant7["option" + (optionIndex2 + 1)]),
      nextOptionValues = variants["filter"](
        (variant8) => variant8["option" + optionIndex2] === selectedOptionValue,
      )["map"]((variant9) => variant9["option" + (optionIndex2 + 1)]);
    options4["forEach"]((optionElement3) => {
      (optionElement3["classList"]["remove"]("unavailable", "non-existent"),
        nextOptionValues["includes"](optionElement3["getAttribute"]("value"))
          ? availableNextOptions["includes"](optionElement3["getAttribute"]("value"))
            ? (optionElement3["innerText"] = optionElement3["getAttribute"]("value"))
            : ((optionElement3["innerText"] = window["variantStrings"]["unavailable_with_option"][
                "replace"
              ]("[value]", optionElement3["getAttribute"]("value"))),
              optionElement3["classList"]["add"]("unavailable"))
          : ((optionElement3["innerText"] = window["variantStrings"]["unavailable_with_option"][
              "replace"
            ]("[value]", optionElement3["getAttribute"]("value"))),
            optionElement3["classList"]["add"]("non-existent")));
    });
  });
}
function findAvailableVariant(
  containerElement3,
  variants3,
  includeUnavailable = forceClose,
  allowPartialMatch = ![],
  foundVariant = ![],
) {
  console["log"]("Running findAvailableVariant");
  for (let lastIndex2 = variants3["length"] - 1; lastIndex2 >= 0; lastIndex2--) {
    const inputElement3 = includeUnavailable
        ? containerElement3["querySelector"](
            ".product-form__input:nth-child(" + (lastIndex2 + 1) + ")",
          )
        : containerElement3["querySelectorAll"](".select")[lastIndex2],
      inputType = includeUnavailable
        ? inputElement3["querySelector"](".product-form__input__type")["dataset"]["type"]
        : "dropdown",
      options5 =
        inputType === "dropdown"
          ? inputElement3["querySelectorAll"]("option")
          : inputElement3["querySelectorAll"]('input[type="radio"]');
    let foundIndex2 = Array["from"](options5)["findIndex"](
        (option4) => option4["value"] === variants3[lastIndex2],
      ),
      found = ![];
    while (foundIndex2 < options5["length"] - 1) {
      foundIndex2++;
      const variantElement = options5[foundIndex2];
      if (
        (!allowPartialMatch || !variantElement["classList"]["contains"]("non-existent")) &&
        (!foundVariant || !variantElement["classList"]["contains"]("unavailable"))
      ) {
        ((variants3[lastIndex2] = variantElement["value"]), (found = forceClose));
        break;
      }
    }
    if (!found) {
      foundIndex2 = Array["from"](options5)["findIndex"](
        (value3) => value3["value"] === variants3[lastIndex2],
      );
      while (foundIndex2 > 0) {
        foundIndex2--;
        const optionElement4 = options5[foundIndex2];
        if (
          (!allowPartialMatch || !optionElement4["classList"]["contains"]("non-existent")) &&
          (!foundVariant || !optionElement4["classList"]["contains"]("unavailable"))
        ) {
          ((variants3[lastIndex2] = optionElement4["value"]), (found = forceClose));
          break;
        }
      }
    }
    if (found)
      return (
        inputType === "dropdown"
          ? (inputElement3["querySelector"](".select__select")["value"] = variants3[lastIndex2])
          : (inputElement3["querySelector"](
              'input[type="radio"][value="' + variants3[lastIndex2] + '"]',
            )["checked"] = forceClose),
        containerElement3["dispatchEvent"](new Event("change")),
        forceClose
      );
  }
  return ![];
}
class QuantityGifts extends HTMLElement {
  constructor() {
    (super(),
      (this["gifts"] = this["querySelectorAll"](".quantity-gift")),
      (this["quantityBreaks"] = document["getElementById"](
        "quantity-breaks-" + this["dataset"]["section"],
      )),
      (this["quantitySelector"] = document["getElementById"](
        "Quantity-Form--" + this["dataset"]["section"],
      )),
      (this["unlockedItems"] = []),
      this["initUnlock"]());
  }
  ["initUnlock"]() {
    let unlockCount = 1;
    if (this["quantityBreaks"]) unlockCount = parseInt(this["quantityBreaks"]["selectedQuantity"]);
    else {
      if (this["quantitySelector"]) {
        const quantityInput2 = this["quantitySelector"]["querySelector"]('input[name="quantity"]');
        unlockCount = parseInt(quantityInput2["value"]);
      }
    }
    this["unlockGifts"](unlockCount);
  }
  ["unlockGifts"](thresholdQuantity) {
    ((this["unlockedItems"] = []),
      this["gifts"]["forEach"]((giftElement) => {
        parseInt(giftElement["dataset"]["quantity"]) <= thresholdQuantity
          ? (giftElement["classList"]["add"]("quantity-gift--unlocked"),
            (giftElement["dataset"]["unlocked"] = "true"),
            this["unlockedItems"]["unshift"](giftElement["dataset"]["product"]))
          : (giftElement["classList"]["remove"]("quantity-gift--unlocked"),
            (giftElement["dataset"]["unlocked"] = "false"));
      }));
  }
}
customElements["define"]("quantity-gifts", QuantityGifts);
class ProductInfoUpsell extends HTMLElement {
  constructor() {
    (super(),
      (this["image"] = this["querySelector"](".upsell__image__img")),
      (this["toggleBtn"] = this["querySelector"](".upsell-toggle-btn")),
      (this["variantSelects"] = this["querySelector"](".upsell__variant-picker")),
      (this["variantSelectElements"] = this["querySelectorAll"](".select__select")),
      (this["jsonData"] = this["querySelector"]('[type="application/json"]')),
      (this["skipNonExistent"] = this["dataset"]["skipNonExistent"] === "true"),
      (this["skipUnavailable"] = this["dataset"]["skipUnavailable"] === "true"),
      (this["updatePrices"] = this["dataset"]["updatePrices"] === "true"));
    if (this["updatePrices"]) {
      ((this["price"] = parseInt(this["dataset"]["price"])),
        (this["comparePrice"] = parseInt(this["dataset"]["comparePrice"])),
        (this["priceSpan"] = this["querySelector"](".upsell__price .regular-price")),
        (this["comparePriceSpan"] = this["querySelector"](".upsell__price .compare-price")),
        (this["percentageLeft"] = parseFloat(this["dataset"]["percentageLeft"])),
        (this["fixedDiscount"] = parseFloat(this["dataset"]["fixedDiscount"])),
        (this["moneyFormat"] = this["dataset"]["moneyFormat"]),
        (this["isMainOfferItem"] = this["dataset"]["mainOfferItem"] === "true"));
      if (this["isMainOfferItem"])
        this["mainOfferContainer"] = document["querySelector"](
          "#MainBundleOffer-" + this["dataset"]["section"],
        );
    }
    if (this["toggleBtn"])
      this["toggleBtn"]["addEventListener"]("click", this["handleToggle"]["bind"](this));
    if (this["variantSelects"])
      this["variantSelects"]["addEventListener"](
        "change",
        this["handleSelectChange"]["bind"](this),
      );
  }
  ["handleToggle"](event34) {
    if (
      event34["target"]["nodeName"]["toLowerCase"]() === "select" ||
      event34["target"]["nodeName"]["toLowerCase"]() === "option"
    )
      return;
    this["dataset"]["selected"] === "true"
      ? (this["dataset"]["selected"] = "false")
      : (this["dataset"]["selected"] = "true");
  }
  ["handleSelectChange"](event35) {
    const currentTarget3 = event35["currentTarget"],
      selectedOptions2 = Array["from"](
        currentTarget3["querySelectorAll"]("select"),
        (select) => select["value"],
      ),
      matchingVariant = this["getVariantData"]()["find"]((variant10) => {
        return !variant10["options"]
          ["map"]((optionValue, optionIndex3) => {
            return selectedOptions2[optionIndex3] === optionValue;
          })
          ["includes"](![]);
      }),
      matchingVariants2 = this["getVariantData"]()["filter"](
        (variant11) =>
          currentTarget3["querySelector"](":checked")["value"] === variant11["option1"],
      ),
      selectElements2 = [...currentTarget3["querySelectorAll"]("select")];
    updateVariantStatuses(matchingVariants2, selectElements2);
    if (!matchingVariant) {
      if (this["skipNonExistent"])
        findAvailableVariant(
          currentTarget3,
          selectedOptions2,
          ![],
          forceClose,
          this["skipUnavailable"],
        );
      return;
    }
    if (this["skipUnavailable"] && !matchingVariant["available"]) {
      if (findAvailableVariant(currentTarget3, selectedOptions2, ![], forceClose, forceClose))
        return;
    }
    this["updatePrices"] &&
      ((this["price"] = matchingVariant["price"] * this["percentageLeft"] - this["fixedDiscount"]),
      (this["comparePrice"] = matchingVariant["price"]),
      matchingVariant["compare_at_price"] &&
        matchingVariant["compare_at_price"] > matchingVariant["price"] &&
        (this["comparePrice"] = matchingVariant["compare_at_price"]),
      displayPrices(
        this["price"],
        this["comparePrice"],
        this["priceSpan"],
        this["comparePriceSpan"],
        this["moneyFormat"],
      ));
    if (this["image"] && matchingVariant["featured_image"])
      this["image"]["src"] = matchingVariant["featured_image"]["src"];
    this["updateId"](matchingVariant["id"]);
    if (this["isMainOfferItem"] && this["mainOfferContainer"]["updateTotalPrices"])
      this["mainOfferContainer"]["updateTotalPrices"]();
  }
  ["updateId"](upsellElement) {
    this["dataset"]["id"] = upsellElement;
  }
  ["getVariantData"]() {
    return (
      (this["variantData"] = this["variantData"] || JSON["parse"](this["jsonData"]["textContent"])),
      this["variantData"]
    );
  }
}
customElements["define"]("product-info-upsell", ProductInfoUpsell);
class CartDrawerUpsell extends ProductInfoUpsell {
  constructor() {
    (super(),
      (this["cartDrawer"] = document["querySelector"]("cart-drawer")),
      (this["cartItems"] = this["cartDrawer"]["querySelector"]("cart-drawer-items")),
      (this["productForm"] = this["querySelector"]("product-form")),
      (this["idInput"] = this["productForm"]["querySelector"]('[name="id"]')),
      (this["classicAddButton"] = this["querySelector"](".upsell__add-btn")));
  }
  ["handleToggle"](event36) {
    if (
      event36["target"]["nodeName"]["toLowerCase"]() === "select" ||
      event36["target"]["nodeName"]["toLowerCase"]() === "option"
    )
      return;
    this["dataset"]["selected"] === "true"
      ? ((this["dataset"]["selected"] = "false"), this["removeFromCart"]())
      : ((this["dataset"]["selected"] = "true"), this["addToCart"]());
  }
  ["addRemoveFromCart"]() {
    this["dataset"]["selected"] === "true" &&
    !this["cartDrawer"]["classList"]["contains"]("is-empty")
      ? this["addToCart"]()
      : this["removeFromCart"]();
  }
  ["addToCart"]() {
    const cartItemElement5 = this["cartDrawer"]["querySelector"](
      ".cart-item--product-" + this["dataset"]["handle"],
    );
    if (cartItemElement5) return;
    if (this["toggleBtn"]) this["toggleBtn"]["setAttribute"]("disabled", "");
    (this["variantSelectElements"]["forEach"]((element16) => {
      element16["setAttribute"]("disabled", "");
    }),
      this["productForm"]["handleSubmit"]());
  }
  ["removeFromCart"]() {
    const upsellCartItemElement = this["cartDrawer"]["querySelector"](
      ".cart-item--product-" + this["dataset"]["handle"],
    );
    if (!upsellCartItemElement || !this["cartItems"]) return;
    if (this["toggleBtn"]) this["toggleBtn"]["setAttribute"]("disabled", "");
    (this["variantSelectElements"]["forEach"]((upsellElement2) => {
      upsellElement2["setAttribute"]("disabled", "");
    }),
      this["cartItems"]["updateQuantity"](upsellCartItemElement["dataset"]["index"], 0));
  }
  ["updateId"](payload) {
    ((this["dataset"]["id"] = payload), (this["idInput"]["value"] = payload));
    if (this["classicAddButton"]) return;
    if (this["dataset"]["selected"] === "true") {
      this["selectTimeout"] && clearTimeout(this["selectTimeout"]);
      this["removeFromCart"]();
      const cartQuantityUpdatedHandler = (event37) => {
        event37["detail"]["handle"] === "handle" &&
          (this["addToCart"](),
          document["removeEventListener"]("cartQuantityUpdated", cartQuantityUpdatedHandler));
      };
      document["addEventListener"]("cartQuantityUpdated", cartQuantityUpdatedHandler);
    }
  }
  ["getUpdateRequired"]() {
    const cartDrawerProductItem = this["cartDrawer"]["querySelector"](
      ".cart-item--product-" + this["dataset"]["handle"],
    );
    let isActive = ![];
    if (cartDrawerProductItem && this["dataset"]["selected"] === "false") isActive = forceClose;
    else
      !cartDrawerProductItem && this["dataset"]["selected"] === "true" && (isActive = forceClose);
    return isActive;
  }
}
customElements["define"]("cart-drawer-upsell", CartDrawerUpsell);
function displayPrices(price2, price3, priceElement, priceElement2, moneyFormat) {
  if (!moneyFormat) return;
  if (price2 && priceElement) {
    var formattedPrice2 = formatMoney(price2, moneyFormat);
    priceElement["innerHTML"] = formattedPrice2;
  }
  if (price3 && priceElement2) {
    var formattedPrice3 = formatMoney(price3, moneyFormat);
    ((priceElement2["innerHTML"] = formattedPrice3),
      price3 > price2
        ? priceElement2["classList"]["remove"]("hidden")
        : priceElement2["classList"]["add"]("hidden"));
  }
}
function formatMoney(amount3, amount4, includeCents = ![]) {
  typeof amount3 == "string" && (amount3 = amount3["replace"](".", ""));
  var replacementString = "",
    placeholderPattern = /\{\{\s*(\w+)\s*\}\}/,
    amountString = amount4;
  function defaultTo(value4, amount5) {
    return typeof value4 == "undefined" ? amount5 : value4;
  }
  function formatMoney2(cents, decimals, amountString2, amount6) {
    ((decimals = defaultTo(decimals, 2)),
      (amountString2 = defaultTo(amountString2, ",")),
      (amount6 = defaultTo(amount6, ".")));
    if (isNaN(cents) || cents == null) return 0;
    cents = (cents / 100)["toFixed"](decimals);
    var amountParts = cents["split"]("."),
      groupedInteger = amountParts[0]["replace"](/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + amountString2),
      decimalSuffix = amountParts[1] ? amount6 + amountParts[1] : "";
    return (
      includeCents && decimalSuffix === amount6 + "00" && (decimalSuffix = ""),
      groupedInteger + decimalSuffix
    );
  }
  switch (amountString["match"](placeholderPattern)[1]) {
    case "amount":
      replacementString = formatMoney2(amount3, 2);
      break;
    case "amount_no_decimals":
      replacementString = formatMoney2(amount3, 0);
      break;
    case "amount_with_comma_separator":
      replacementString = formatMoney2(amount3, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      replacementString = formatMoney2(amount3, 0, ".", ",");
      break;
  }
  return amountString["replace"](placeholderPattern, replacementString);
}
class CartDrawerGift extends CartDrawerUpsell {
  constructor() {
    super();
  }
}
customElements["define"]("cart-drawer-gift", CartDrawerGift);
function initToggleUpsells() {
  const cartDrawer2 = document["querySelector"]("cart-drawer");
  cartDrawer2 &&
    cartDrawer2["querySelectorAll"]('cart-drawer-upsell[data-toggle="true"], cart-drawer-gift')[
      "forEach"
    ]((upsell) => {
      if (upsell["addRemoveFromCart"]) upsell["addRemoveFromCart"]();
    });
}
initToggleUpsells();
class MainBundleOffer extends HTMLElement {
  constructor() {
    (super(),
      (this["offerItems"] = this["querySelectorAll"](".main-offer-item")),
      (this["updatePrices"] = this["dataset"]["updatePrices"] === "true"),
      this["updatePrices"] &&
        ((this["priceSpan"] = this["querySelector"](".bundle-deals__total-price-js")),
        (this["comparePriceSpan"] = this["querySelector"](".bundle-deals__total-compare-price-js")),
        (this["percentageLeft"] = parseFloat(this["dataset"]["percentageLeft"])),
        (this["fixedDiscount"] = parseFloat(this["dataset"]["fixedDiscount"])),
        (this["moneyFormat"] = this["dataset"]["moneyFormat"])));
  }
  ["updateTotalPrices"]() {
    if (!this["updatePrices"]) return;
    var discountAmount2 = 0,
      index15 = 0;
    for (let offerIndex = 0; offerIndex < this["offerItems"]["length"]; offerIndex++) {
      ((discountAmount2 += parseInt(this["offerItems"][offerIndex]["price"])),
        (index15 += parseInt(this["offerItems"][offerIndex]["comparePrice"])));
    }
    ((discountAmount2 = discountAmount2 * this["percentageLeft"] - this["fixedDiscount"]),
      displayPrices(
        discountAmount2,
        index15,
        this["priceSpan"],
        this["comparePriceSpan"],
        this["moneyFormat"],
      ));
  }
}
customElements["define"]("main-bundle-offer", MainBundleOffer);
class CustomProductField extends HTMLElement {
  constructor() {
    super();
  }
  ["connectedCallback"]() {
    ((this["fieldName"] = this["dataset"]["name"]),
      (this["input"] = this["querySelector"]('[type="text"], [type="number"], textarea')),
      (this["inputRadios"] = this["querySelectorAll"]('[type="radio"]')),
      (this["select"] = this["querySelector"](".select__select")),
      (this["productForm"] = document["getElementById"](
        "product-form-" + this["dataset"]["section"],
      )),
      (this["prevValue"] = this["dataset"]["defaultValue"]),
      (this["isRequired"] = this["dataset"]["required"] === "true"),
      (this["isText"] = forceClose),
      (this["notMain"] = this["dataset"]["notMain"] === "true"));
    if (this["dataset"]["type"] === "select" || this["dataset"]["type"] === "pills")
      this["isText"] = ![];
    this["createInputs"]();
    this["isRequired"] &&
      this["isText"] &&
      ((this["isValid"] = forceClose),
      (this["atcButtons"] = this["notMain"]
        ? document["querySelectorAll"](".featured-product-atc-" + this["dataset"]["section"])
        : document["querySelectorAll"](".main-product-atc")),
      (this["mainAtcButton"] = this["productForm"]["querySelector"](
        "#ProductSubmitButton-" + this["dataset"]["section"],
      )),
      (this["mainAtcBtnLabel"] = this["mainAtcButton"]["querySelector"](".main-atc__label")),
      (this["mainAtcBtnError"] = this["mainAtcButton"]["querySelector"](".main-atc__error")),
      (this["atcErrorMsg"] = this["dataset"]["atcErrorMsg"]),
      (this["mainAtcButton"]["dataset"]["requiredFields"] =
        parseInt(this["mainAtcButton"]["dataset"]["requiredFields"]) + 1),
      (this["mainAtcBtnError"]["innerHTML"] = this["atcErrorMsg"]),
      (this["applyStickyAtcError"] = this["dataset"]["applyStickyAtcError"] === "true"),
      (this["stickyAtcButton"] = document["querySelector"](
        "#sticky-atc-" + this["dataset"]["section"],
      )),
      this["applyStickyAtcError"] &&
        this["stickyAtcButton"] &&
        ((this["stickyAtcBtnLabel"] =
          this["stickyAtcButton"]["querySelector"](".sticky-atc__label")),
        (this["stickyAtcBtnError"] =
          this["stickyAtcButton"]["querySelector"](".sticky-atc__error")),
        (this["stickyAtcBtnError"]["innerHTML"] = this["atcErrorMsg"])),
      this["validateValue"](this["prevValue"], null));
    if (this["input"])
      this["input"]["addEventListener"]("input", this["handleChange"]["bind"](this));
    this["inputRadios"]["forEach"]((element17) => {
      element17["addEventListener"]("input", this["handleChange"]["bind"](this));
    });
    if (this["select"])
      this["select"]["addEventListener"]("change", this["handleChange"]["bind"](this));
  }
  ["handleChange"](event38) {
    const fieldValue = event38["target"]["value"]["trim"]();
    if (event38["target"]["checkValidity"]()) this["prevValue"] = fieldValue;
    else {
      event38["target"]["value"] = this["prevValue"];
      return;
    }
    ((this["dataset"]["value"] = fieldValue), (this["productFormInput"]["value"] = fieldValue));
    if (this["isRequired"] && this["isText"]) this["validateValue"](fieldValue, event38["target"]);
  }
  ["validateValue"](value5, inputElement4) {
    const computedIsValid = value5["length"] > 0 ? forceClose : ![];
    if (computedIsValid === this["isValid"]) return;
    this["isValid"] = computedIsValid;
    inputElement4 &&
      (this["isValid"]
        ? (inputElement4["classList"]["remove"]("input--error"),
          (this["mainAtcButton"]["dataset"]["validFields"] =
            parseInt(this["mainAtcButton"]["dataset"]["validFields"]) + 1))
        : (inputElement4["classList"]["add"]("input--error"),
          (this["mainAtcButton"]["dataset"]["validFields"] =
            parseInt(this["mainAtcButton"]["dataset"]["validFields"]) - 1)));
    const requiredFieldsValid =
        this["mainAtcButton"]["dataset"]["validFields"] ===
        this["mainAtcButton"]["dataset"]["requiredFields"],
      isMainAtcUnavailable = this["mainAtcButton"]["dataset"]["unavailable"] === "true";
    this["atcButtons"]["forEach"]((fieldElement) => {
      requiredFieldsValid && !isMainAtcUnavailable
        ? fieldElement["removeAttribute"]("disabled")
        : fieldElement["setAttribute"]("disabled", "");
    });
    if (this["atcErrorMsg"]["length"] === 0) return;
    requiredFieldsValid
      ? ((this["mainAtcBtnLabel"]["style"]["display"] = ""),
        (this["mainAtcBtnError"]["style"]["display"] = "none"),
        this["applyStickyAtcError"] &&
          this["stickyAtcButton"] &&
          ((this["stickyAtcBtnLabel"]["style"]["display"] = ""),
          (this["stickyAtcBtnError"]["style"]["display"] = "none")))
      : ((this["mainAtcBtnLabel"]["style"]["display"] = "none"),
        (this["mainAtcBtnError"]["style"]["display"] = ""),
        this["applyStickyAtcError"] &&
          this["stickyAtcButton"] &&
          ((this["stickyAtcBtnLabel"]["style"]["display"] = "none"),
          (this["stickyAtcBtnError"]["style"]["display"] = "")));
  }
  ["createInputs"]() {
    ((this["productFormInput"] = document["createElement"]("input")),
      this["productFormInput"]["setAttribute"]("type", "hidden"),
      this["productFormInput"]["setAttribute"]("name", "properties[" + this["fieldName"] + "]"),
      (this["productFormInput"]["value"] = this["dataset"]["defaultValue"]),
      this["productForm"]["appendChild"](this["productFormInput"]));
  }
}
customElements["define"]("custom-product-field", CustomProductField);
class VariantSelects extends HTMLElement {
  constructor() {
    (super(),
      (this["secondarySelectSelector"] = "StickyAtcVariantPicker-"),
      (this["secondarySelect"] = document["getElementById"](
        "" + this["secondarySelectSelector"] + this["dataset"]["section"],
      )),
      (this["isSecondary"] = ![]),
      (this["QuantityBreaks"] = document["getElementById"](
        "quantity-breaks-" + this["dataset"]["section"],
      )),
      (this["hasQuantityBreaksPicker"] = this["dataset"]["hasQuantityBreaksPicker"] === "true"),
      (this["prependMedia"] = this["dataset"]["disablePrepend"] != "true"),
      (this["filtering"] = this["dataset"]["hasFiltering"] === "true"),
      (this["skipNonExistent"] = this["dataset"]["skipNonExistent"] === "true"),
      (this["skipUnavailable"] = this["dataset"]["skipUnavailable"] === "true"),
      this["hasQuantityBreaksPicker"] &&
        ((this["quantityBreaksPickerStyle"] = this["dataset"]["quantityBreaksPickerStyle"]),
        (this["quantityBreaksPickerDisplayedImages"] =
          this["dataset"]["quantityBreaksPickerDisplayedImages"])),
      this["addEventListener"]("change", this["onVariantChange"]));
  }
  ["onVariantChange"]() {
    (this["updateOptions"](),
      this["updateMasterId"](),
      this["toggleAddButton"](forceClose, "", ![]),
      this["updatePickupAvailability"](),
      this["removeErrorMessage"](),
      this["updateVariantStatuses"]());
    if (!this["currentVariant"]) {
      this["toggleAddButton"](forceClose, "", forceClose);
      if (
        this["skipNonExistent"] &&
        findAvailableVariant(this, this["options"], forceClose, forceClose, this["skipUnavailable"])
      )
        return;
      this["setUnavailable"]();
    } else {
      if (this["skipUnavailable"] && !this["currentVariant"]["available"]) {
        if (findAvailableVariant(this, this["options"], forceClose, forceClose, forceClose)) return;
      }
      (this["updateMedia"](),
        this["updateURL"](),
        this["updateVariantInput"](),
        this["renderProductInfo"](),
        this["updateShareUrl"]());
    }
  }
  ["updateOptions"]() {
    const variantOptions = [];
    (this["querySelectorAll"](".product-form__input")["forEach"]((sectionElement) => {
      let optionValue2;
      const inputType2 = sectionElement["querySelector"](".product-form__input__type")["dataset"][
        "type"
      ];
      (inputType2 == "dropdown" || inputType2 == "dropdwon"
        ? (optionValue2 = sectionElement["querySelector"](".select__select")["value"])
        : (optionValue2 = sectionElement["querySelector"]('input[type="radio"]:checked')["value"]),
        variantOptions["push"](optionValue2));
    }),
      (this["options"] = variantOptions));
  }
  ["updateMasterId"]() {
    this["currentVariant"] = this["getVariantData"]()["find"]((selectElement3) => {
      return !selectElement3["options"]
        ["map"]((optionValue3, optionIndex4) => {
          return this["options"][optionIndex4] === optionValue3;
        })
        ["includes"](![]);
    });
  }
  ["updateMedia"]() {
    if (!this["currentVariant"]) return;
    if (!this["currentVariant"]["featured_media"]) return;
    const mediaGalleries = document["querySelectorAll"](
      '[id^="MediaGallery-' + this["dataset"]["section"] + '"]',
    );
    mediaGalleries["forEach"]((media2) =>
      media2["setActiveMedia"](
        this["dataset"]["section"] + "-" + this["currentVariant"]["featured_media"]["id"],
        this["prependMedia"],
        this["filtering"],
        this["currentVariant"],
      ),
    );
    const productModalContent = document["querySelector"](
      "#ProductModal-" + this["dataset"]["section"] + " .product-media-modal__content",
    );
    if (!productModalContent) return;
    const mediaElement2 = productModalContent["querySelector"](
      '[data-media-id="' + this["currentVariant"]["featured_media"]["id"] + '"]',
    );
    productModalContent["prepend"](mediaElement2);
  }
  ["updateURL"]() {
    if (!this["currentVariant"] || this["dataset"]["updateUrl"] === "false") return;
    window["history"]["replaceState"](
      {},
      "",
      this["dataset"]["url"] + "?variant=" + this["currentVariant"]["id"],
    );
  }
  ["updateShareUrl"]() {
    const shareElement = document["getElementById"]("Share-" + this["dataset"]["section"]);
    if (!shareElement || !shareElement["updateUrl"]) return;
    shareElement["updateUrl"](
      "" + window["shopUrl"] + this["dataset"]["url"] + "?variant=" + this["currentVariant"]["id"],
    );
  }
  ["updateVariantInput"]() {
    const productFormElements2 = document["querySelectorAll"](
      "#product-form-" +
        this["dataset"]["section"] +
        ", #product-form-installment-" +
        this["dataset"]["section"],
    );
    productFormElements2["forEach"]((container3) => {
      const variantIdInput = container3["querySelector"]('input[name="id"]');
      ((variantIdInput["value"] = this["currentVariant"]["id"]),
        variantIdInput["dispatchEvent"](
          new Event("change", {
            bubbles: forceClose,
          }),
        ));
    });
  }
  ["updateVariantStatuses"]() {
    const matchingVariants3 = this["variantData"]["filter"](
      (variant12) => this["querySelector"](":checked")["value"] === variant12["option1"],
    );
    let variantSelects;
    (this["isSecondary"] && this["secondarySelect"]
      ? (variantSelects = [...this["secondarySelect"]["querySelectorAll"](".product-form__input")])
      : (variantSelects = [...this["querySelectorAll"](".product-form__input")]),
      variantSelects["forEach"]((container4, optionIndex5) => {
        if (optionIndex5 === 0) return;
        const inputs = [
            ...container4["querySelectorAll"]('input[type="radio"], .select__select option'),
          ],
          selectedOptionValue2 =
            variantSelects[optionIndex5 - 1]["querySelector"](":checked")["value"],
          availableNextOptions2 = matchingVariants3["filter"](
            (variant13) =>
              variant13["available"] && variant13["option" + optionIndex5] === selectedOptionValue2,
          )["map"]((variant14) => variant14["option" + (optionIndex5 + 1)]),
          matchingNextOptions = matchingVariants3["filter"](
            (variant15) => variant15["option" + optionIndex5] === selectedOptionValue2,
          )["map"]((optionItem2) => optionItem2["option" + (optionIndex5 + 1)]);
        this["setInputAvailability"](inputs, availableNextOptions2, matchingNextOptions);
      }));
  }
  ["setInputAvailability"](options6, optionValue4, values) {
    options6["forEach"]((selectElement4) => {
      selectElement4["classList"]["remove"]("unavailable", "non-existent", "disabled");
      const optionValue5 = selectElement4["getAttribute"]("value");
      let activeElement = null;
      selectElement4["dataset"]["swatch"] === "true" &&
        (activeElement = selectElement4["closest"](".color-swatch"));
      if (activeElement)
        activeElement["classList"]["remove"]("unavailable", "non-existent", "disabled");
      if (values["includes"](optionValue5)) {
        if (optionValue4["includes"](optionValue5)) {
          if (selectElement4["nodeName"] === "OPTION") selectElement4["innerText"] = optionValue5;
          else {
            selectElement4["classList"]["remove"]("disabled");
            if (activeElement) activeElement["classList"]["remove"]("disabled");
          }
        } else {
          if (selectElement4["nodeName"] === "OPTION")
            ((selectElement4["innerText"] = window["variantStrings"]["unavailable_with_option"][
              "replace"
            ]("[value]", optionValue5)),
              selectElement4["classList"]["add"]("unavailable"));
          else {
            selectElement4["classList"]["add"]("disabled", "unavailable");
            if (activeElement) activeElement["classList"]["add"]("disabled", "unavailable");
          }
        }
      } else {
        if (selectElement4["nodeName"] === "OPTION")
          ((selectElement4["innerText"] = window["variantStrings"]["unavailable_with_option"][
            "replace"
          ]("[value]", optionValue5)),
            selectElement4["classList"]["add"]("non-existent"));
        else {
          selectElement4["classList"]["add"]("disabled", "non-existent");
          if (activeElement) activeElement["classList"]["add"]("disabled", "non-existent");
        }
      }
    });
  }
  ["updatePickupAvailability"]() {
    const pickupAvailability = document["querySelector"]("pickup-availability");
    if (!pickupAvailability) return;
    if (this["currentVariant"] && this["currentVariant"]["available"]) {
      if (pickupAvailability["fetchAvailability"])
        pickupAvailability["fetchAvailability"](this["currentVariant"]["id"]);
    } else
      (pickupAvailability["removeAttribute"]("available"), (pickupAvailability["innerHTML"] = ""));
  }
  ["removeErrorMessage"]() {
    const sectionElement2 = this["closest"]("section");
    if (!sectionElement2) return;
    const productForm = sectionElement2["querySelector"]("product-form");
    if (productForm) productForm["handleErrorMessage"]();
  }
  ["renderProductInfo"]() {
    const currentVariantId = this["currentVariant"]["id"],
      sectionId3 = this["dataset"]["originalSection"]
        ? this["dataset"]["originalSection"]
        : this["dataset"]["section"];
    fetch(
      this["dataset"]["url"] +
        "?variant=" +
        currentVariantId +
        "&section_id=" +
        (this["dataset"]["originalSection"]
          ? this["dataset"]["originalSection"]
          : this["dataset"]["section"]),
    )
      ["then"]((option5) => option5["text"]())
      ["then"]((htmlString8) => {
        if (this["currentVariant"]["id"] !== currentVariantId) return;
        const parsedHtml3 = new DOMParser()["parseFromString"](htmlString8, "text/html"),
          priceElement3 = document["getElementById"]("price-" + this["dataset"]["section"]),
          priceElement4 = parsedHtml3["getElementById"](
            "price-" +
              (this["dataset"]["originalSection"]
                ? this["dataset"]["originalSection"]
                : this["dataset"]["section"]),
          ),
          stickySeparatePriceElement = document["getElementById"](
            "sticky-atc-separate-price-" + this["dataset"]["section"],
          ),
          stickyAtcPriceElement = parsedHtml3["getElementById"](
            "sticky-atc-separate-price-" +
              (this["dataset"]["originalSection"]
                ? this["dataset"]["originalSection"]
                : this["dataset"]["section"]),
          ),
          stickyAtcPriceElement2 = document["getElementById"](
            "sticky-atc-price-" + this["dataset"]["section"],
          ),
          stickyAtcPriceElement3 = parsedHtml3["getElementById"](
            "sticky-atc-price-" +
              (this["dataset"]["originalSection"]
                ? this["dataset"]["originalSection"]
                : this["dataset"]["section"]),
          ),
          stickyAtcImage = document["getElementById"](
            "sticky-atc-image-" + this["dataset"]["section"],
          ),
          stickyAtcImage2 = parsedHtml3["getElementById"](
            "sticky-atc-image-" +
              (this["dataset"]["originalSection"]
                ? this["dataset"]["originalSection"]
                : this["dataset"]["section"]),
          ),
          mainAtcPriceElement = document["getElementById"](
            "main-atc-price-" + this["dataset"]["section"],
          ),
          mainAtcPriceElement2 = parsedHtml3["getElementById"](
            "main-atc-price-" +
              (this["dataset"]["originalSection"]
                ? this["dataset"]["originalSection"]
                : this["dataset"]["section"]),
          ),
          customLabels = document["querySelectorAll"](
            '[id^="custom-label-' + this["dataset"]["section"] + '"]',
          ),
          customLabels2 = parsedHtml3["querySelectorAll"](
            '[id^="custom-label-' +
              (this["dataset"]["originalSection"]
                ? this["dataset"]["originalSection"]
                : this["dataset"]["section"]) +
              '"]',
          ),
          skuElement = parsedHtml3["getElementById"](
            "Sku-" +
              (this["dataset"]["originalSection"]
                ? this["dataset"]["originalSection"]
                : this["dataset"]["section"]),
          ),
          skuElement2 = document["getElementById"]("Sku-" + this["dataset"]["section"]),
          inventoryElement = parsedHtml3["getElementById"](
            "Inventory-" +
              (this["dataset"]["originalSection"]
                ? this["dataset"]["originalSection"]
                : this["dataset"]["section"]),
          ),
          inventoryElement2 = document["getElementById"]("Inventory-" + this["dataset"]["section"]);
        if (priceElement3 && priceElement4) priceElement3["innerHTML"] = priceElement4["innerHTML"];
        if (stickySeparatePriceElement && stickyAtcPriceElement)
          stickySeparatePriceElement["innerHTML"] = stickyAtcPriceElement["innerHTML"];
        if (stickyAtcPriceElement2 && stickyAtcPriceElement3)
          stickyAtcPriceElement2["innerHTML"] = stickyAtcPriceElement3["innerHTML"];
        if (stickyAtcImage && stickyAtcImage2) stickyAtcImage["src"] = stickyAtcImage2["src"];
        if (mainAtcPriceElement2 && mainAtcPriceElement)
          mainAtcPriceElement["innerHTML"] = mainAtcPriceElement2["innerHTML"];
        if (customLabels && customLabels2)
          for (var index16 = 0; index16 < customLabels["length"]; index16++) {
            customLabels[index16]["innerHTML"] = customLabels2[index16]["innerHTML"];
          }
        if (inventoryElement && inventoryElement2)
          inventoryElement2["innerHTML"] = inventoryElement["innerHTML"];
        skuElement &&
          skuElement2 &&
          ((skuElement2["innerHTML"] = skuElement["innerHTML"]),
          skuElement2["classList"]["toggle"](
            "visibility-hidden",
            skuElement["classList"]["contains"]("visibility-hidden"),
          ));
        if (this["QuantityBreaks"]) {
          const quantityBreaks2 = parsedHtml3["getElementById"](
              "quantity-breaks-" +
                (this["dataset"]["originalSection"]
                  ? this["dataset"]["originalSection"]
                  : this["dataset"]["section"]),
            ),
            dynamicPriceElements = this["QuantityBreaks"]["querySelectorAll"](".dynamic-price"),
            dynamicPriceElements2 = quantityBreaks2["querySelectorAll"](".dynamic-price");
          for (
            let optionIndex6 = 0;
            optionIndex6 < dynamicPriceElements["length"];
            optionIndex6++
          ) {
            dynamicPriceElements[optionIndex6]["innerHTML"] =
              dynamicPriceElements2[optionIndex6]["innerHTML"];
          }
          if (this["QuantityBreaks"]["hasVariants"]) {
            this["QuantityBreaks"]["variantSelects"]["forEach"]((selectElement5) => {
              selectElement5["dataset"]["selectedId"] = this["currentVariant"]["id"];
            });
            const variantSelects2 = this["QuantityBreaks"]["querySelectorAll"](
                ".quantity-break__variant-select",
              ),
              variantSelects3 = quantityBreaks2["querySelectorAll"](
                ".quantity-break__variant-select",
              );
            for (let optionIndex7 = 0; optionIndex7 < variantSelects2["length"]; optionIndex7++) {
              variantSelects2[optionIndex7]["innerHTML"] =
                variantSelects3[optionIndex7]["innerHTML"];
            }
            this["QuantityBreaks"]["initVariants"]();
          }
        }
        if (this["hasQuantityBreaksPicker"]) {
          const variantSelectsElement = parsedHtml3["getElementById"](
              "variant-selects-" +
                (this["dataset"]["originalSection"]
                  ? this["dataset"]["originalSection"]
                  : this["dataset"]["section"]),
            ),
            dynamicPrices = this["querySelectorAll"](".dynamic-price"),
            dynamicPriceElements3 = variantSelectsElement["querySelectorAll"](".dynamic-price");
          for (let index17 = 0; index17 < dynamicPrices["length"]; index17++) {
            dynamicPrices[index17]["innerHTML"] = dynamicPriceElements3[index17]["innerHTML"];
          }
          if (
            this["quantityBreaksPickerStyle"] === "vertical" &&
            this["quantityBreaksPickerDisplayedImages"] === "variant_images"
          ) {
            const quantityBreakImages = this["querySelectorAll"](".quantity-break__image img"),
              quantityBreakImages2 = variantSelectsElement["querySelectorAll"](
                ".quantity-break__image img",
              );
            for (let index18 = 0; index18 < quantityBreakImages["length"]; index18++) {
              quantityBreakImages[index18]["src"] = quantityBreakImages2[index18]["src"];
            }
          }
        }
        if (this["secondarySelect"]) {
          const secondarySelectElement = parsedHtml3["getElementById"](
            "" +
              this["secondarySelectSelector"] +
              (this["dataset"]["originalSection"]
                ? this["dataset"]["originalSection"]
                : this["dataset"]["section"]),
          );
          if (secondarySelectElement)
            this["secondarySelect"]["innerHTML"] = secondarySelectElement["innerHTML"];
        }
        const priceElement5 = document["getElementById"]("price-" + this["dataset"]["section"]);
        if (priceElement5) priceElement5["classList"]["remove"]("visibility-hidden");
        if (inventoryElement2)
          inventoryElement2["classList"]["toggle"](
            "visibility-hidden",
            inventoryElement["innerText"] === "",
          );
        const productSubmitButton = parsedHtml3["getElementById"](
          "ProductSubmitButton-" + sectionId3,
        );
        (this["toggleAddButton"](
          productSubmitButton ? productSubmitButton["hasAttribute"]("disabled") : forceClose,
          window["variantStrings"]["soldOut"],
        ),
          publish(PUB_SUB_EVENTS["variantChange"], {
            data: {
              sectionId: sectionId3,
              html: parsedHtml3,
              variant: this["currentVariant"],
            },
          }));
      });
  }
  ["toggleAddButton"](isVariant = forceClose, event39, isSelected = forceClose) {
    const productFormElement2 = document["getElementById"](
      "product-form-" + this["dataset"]["section"],
    );
    if (!productFormElement2) return;
    const addButton = productFormElement2["querySelector"]('[name="add"]'),
      mainProductAtcElements = document["querySelectorAll"](".main-product-atc");
    var atcLabelText = productFormElement2["querySelector"](".main-atc__label__text");
    if (!atcLabelText) atcLabelText = productFormElement2["querySelector"](".main-atc__label");
    const mainAtcPriceNode = productFormElement2["querySelector"](".main-atc-price");
    if (!addButton) return;
    if (isVariant) {
      (addButton["setAttribute"]("disabled", "disabled"),
        addButton["setAttribute"]("data-unavailable", "true"));
      if (event39) atcLabelText["textContent"] = event39;
      mainProductAtcElements["forEach"]((element18) => {
        element18["setAttribute"]("disabled", "disabled");
      });
      if (mainAtcPriceNode) mainAtcPriceNode["classList"]["add"]("hidden");
    } else {
      (addButton["setAttribute"]("data-unavailable", "false"),
        (atcLabelText["textContent"] = window["variantStrings"]["addToCart"]));
      if (mainAtcPriceNode) mainAtcPriceNode["classList"]["remove"]("hidden");
      addButton["dataset"]["requiredFields"] === addButton["dataset"]["validFields"] &&
        (addButton["removeAttribute"]("disabled"),
        mainProductAtcElements["forEach"]((element19) => {
          element19["removeAttribute"]("disabled");
        }));
    }
    if (!isSelected) return;
  }
  ["setUnavailable"]() {
    const productForm2 = document["getElementById"]("product-form-" + this["dataset"]["section"]);
    if (!productForm2) return;
    const addButton2 = productForm2["querySelector"]('[name="add"]');
    var atcLabelTextElement = productForm2["querySelector"](".main-atc__label__text");
    if (!atcLabelTextElement)
      atcLabelTextElement = productForm2["querySelector"](".main-atc__label");
    const priceElement6 = document["getElementById"]("price-" + this["dataset"]["section"]),
      inventoryElement3 = document["getElementById"]("Inventory-" + this["dataset"]["section"]),
      skuElement3 = document["getElementById"]("Sku-" + this["dataset"]["section"]);
    if (!addButton2) return;
    atcLabelTextElement["textContent"] = window["variantStrings"]["unavailable"];
    if (priceElement6) priceElement6["classList"]["add"]("visibility-hidden");
    if (inventoryElement3) inventoryElement3["classList"]["add"]("visibility-hidden");
    if (skuElement3) skuElement3["classList"]["add"]("visibility-hidden");
  }
  ["getVariantData"]() {
    return (
      (this["variantData"] =
        this["variantData"] ||
        JSON["parse"](this["querySelector"]('[type="application/json"]')["textContent"])),
      this["variantData"]
    );
  }
}
customElements["define"]("variant-selects", VariantSelects);
class SecondaryVariantSelect extends VariantSelects {
  constructor() {
    (super(),
      (this["secondarySelectSelector"] = "variant-selects-"),
      (this["secondarySelect"] = document["getElementById"](
        "" + this["secondarySelectSelector"] + this["dataset"]["section"],
      )),
      (this["isSecondary"] = forceClose));
  }
  ["updateOptions"]() {
    this["options"] = this["querySelector"]("select")["value"]["split"](",");
  }
}
customElements["define"]("secondary-variant-select", SecondaryVariantSelect);
class SecondaryVariantSelectSeparate extends VariantSelects {
  constructor() {
    (super(),
      (this["secondarySelectSelector"] = "variant-selects-"),
      (this["secondarySelect"] = document["getElementById"](
        "" + this["secondarySelectSelector"] + this["dataset"]["section"],
      )),
      (this["isSecondary"] = forceClose));
  }
}
customElements["define"]("secondary-variant-select-separate", SecondaryVariantSelectSeparate);
class CardVariantSelects extends VariantSelects {
  constructor() {
    (super(),
      (this["quickAddSubmit"] = document["getElementById"](
        this["dataset"]["section"] + "-submit",
      )));
  }
  ["onVariantChange"]() {
    (this["updateOptions"](),
      this["updateMasterId"](),
      this["toggleAddButton"](forceClose, "", ![]),
      this["updateVariantStatuses"](),
      !this["currentVariant"]
        ? (this["toggleAddButton"](forceClose, "", forceClose), this["setUnavailable"]())
        : (this["updateMedia"](),
          this["updateVariantInput"](),
          this["updateQuickAddUrl"](),
          this["toggleAddButton"](
            !this["currentVariant"]["available"],
            window["variantStrings"]["soldOut"],
          )));
  }
  ["updateMedia"]() {
    if (!this["currentVariant"] || !this["currentVariant"]["featured_media"]) return;
    const sectionImage = document["getElementById"](this["dataset"]["section"] + "-image");
    if (!sectionImage) return;
    const previewImage = this["currentVariant"]["featured_media"]["preview_image"],
      imageSrcBase = previewImage["src"]["split"]("?")[0],
      sizes = [165, 360, 533, 720, 940, 1066],
      srcSetString = sizes["filter"]((candidateWidth) => previewImage["width"] >= candidateWidth)
        ["map"]((width) => imageSrcBase + "?width=" + width + " " + width + "w")
        ["join"](", ");
    ((sectionImage["srcset"] =
      srcSetString + ", " + imageSrcBase + " " + previewImage["width"] + "w"),
      (sectionImage["src"] = imageSrcBase + "?width=533"));
  }
  ["updateQuickAddUrl"]() {
    if (!this["currentVariant"] || !this["quickAddSubmit"]) return;
    this["quickAddSubmit"]["dataset"]["productUrl"] =
      this["dataset"]["url"] + "?variant=" + this["currentVariant"]["id"];
  }
}
customElements["define"]("card-variant-selects", CardVariantSelects);
